var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon0, _polygon1, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24, _polygon25, _polygon26, _polygon27, _polygon28, _polygon29, _polygon30, _rect, _polygon31, _polygon32, _polygon33, _polygon34, _polygon35, _polygon36, _polygon37, _polygon38, _rect2, _polygon39, _polygon40, _rect3, _rect4, _polygon41, _rect5, _polygon42, _rect6, _polygon43, _polygon44, _polygon45, _rect7, _rect8, _polygon46, _polygon47, _polygon48, _polygon49, _polygon50, _polygon51, _polygon52, _polygon53, _polygon54, _polygon55, _polygon56, _polygon57, _polygon58, _polygon59, _polygon60, _polygon61, _polygon62, _polygon63, _polygon64, _polygon65, _polygon66, _polygon67, _polygon68, _polygon69, _polygon70, _polygon71, _polygon72, _polygon73, _polygon74, _polygon75, _polygon76, _polygon77, _polygon78, _polygon79, _polygon80, _polygon81, _polygon82, _polygon83, _polygon84, _polygon85, _polygon86, _polygon87, _polygon88, _polygon89, _polygon90, _polygon91, _polygon92, _polygon93, _polygon94, _polygon95, _polygon96, _polygon97, _polygon98, _polygon99, _polygon100, _polygon101, _polygon102, _polygon103, _polygon104, _polygon105, _polygon106, _polygon107, _polygon108, _polygon109, _polygon110, _polygon111, _polygon112, _polygon113, _polygon114, _polygon115, _polygon116, _polygon117, _polygon118, _polygon119, _polygon120, _polygon121, _polygon122, _polygon123, _polygon124, _polygon125, _polygon126, _polygon127, _polygon128, _polygon129, _polygon130, _polygon131, _polygon132, _polygon133, _polygon134, _polygon135, _polygon136, _polygon137, _polygon138, _polygon139, _polygon140, _polygon141, _polygon142, _polygon143, _polygon144, _polygon145, _polygon146, _polygon147, _polygon148, _polygon149, _polygon150, _polygon151, _polygon152, _polygon153, _polygon154, _polygon155, _polygon156, _polygon157, _polygon158, _polygon159, _polygon160, _polygon161, _polygon162, _polygon163, _polygon164, _polygon165, _polygon166, _polygon167, _polygon168, _polygon169, _polygon170, _polygon171, _polygon172, _polygon173, _polygon174, _polygon175, _polygon176, _polygon177, _polygon178, _polygon179, _polygon180, _polygon181, _polygon182, _polygon183, _polygon184, _polygon185, _polygon186, _polygon187, _polygon188, _polygon189, _polygon190, _polygon191, _polygon192, _polygon193, _polygon194, _polygon195, _polygon196, _polygon197, _polygon198, _polygon199, _polygon200, _polygon201, _polygon202, _polygon203, _polygon204, _polygon205, _polygon206, _polygon207, _polygon208, _polygon209, _polygon210, _polygon211, _polygon212, _polygon213, _polygon214, _polygon215, _polygon216, _polygon217, _polygon218, _polygon219, _polygon220, _polygon221, _polygon222, _polygon223, _polygon224, _polygon225, _polygon226, _polygon227, _polygon228, _polygon229, _polygon230, _polygon231, _polygon232, _rect9, _polygon233, _polygon234, _polygon235, _polygon236, _polygon237, _polygon238, _polygon239, _polygon240, _polygon241, _polygon242, _polygon243, _polygon244, _polygon245, _polygon246, _polygon247, _polygon248, _polygon249, _polygon250, _polygon251, _polygon252, _polygon253, _polygon254, _polygon255, _polygon256, _rect0, _polygon257, _polygon258, _rect1, _polygon259, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _polygon260, _rect26, _polygon261, _polygon262, _polygon263, _polygon264, _rect27, _rect28, _polygon265, _polygon266, _polygon267, _polygon268, _polygon269, _polygon270, _polygon271, _polygon272, _polygon273, _polygon274, _polygon275, _polygon276, _polygon277, _polygon278, _polygon279, _polygon280, _polygon281, _polygon282, _polygon283, _polygon284, _rect29, _polygon285, _rect30, _polygon286, _polygon287, _rect31, _polygon288, _rect32, _polygon289, _polygon290, _polygon291, _polygon292, _polygon293, _polygon294, _polygon295, _polygon296, _polygon297, _polygon298, _polygon299, _polygon300, _polygon301, _polygon302, _polygon303, _polygon304, _polygon305, _polygon306, _polygon307, _polygon308, _polygon309, _polygon310, _polygon311, _polygon312, _polygon313, _polygon314, _polygon315, _polygon316, _polygon317, _polygon318, _polygon319, _polygon320, _polygon321, _polygon322, _polygon323, _polygon324, _polygon325, _rect33, _polygon326, _polygon327, _rect34, _polygon328, _rect35, _polygon329, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _polygon330, _polygon331, _polygon332, _polygon333, _polygon334, _polygon335, _polygon336, _polygon337, _polygon338, _polygon339, _polygon340, _polygon341, _polygon342, _polygon343, _polygon344, _polygon345, _polygon346, _polygon347, _polygon348, _polygon349, _polygon350, _polygon351, _polygon352, _polygon353, _polygon354, _polygon355, _polygon356, _polygon357, _polygon358, _polygon359, _polygon360, _polygon361, _polygon362, _polygon363, _polygon364, _polygon365, _polygon366, _polygon367, _polygon368, _polygon369, _polygon370, _polygon371, _polygon372, _polygon373, _rect44, _polygon374, _polygon375, _polygon376, _polygon377, _polygon378, _polygon379, _polygon380, _polygon381, _polygon382, _polygon383, _polygon384, _polygon385, _polygon386, _polygon387, _polygon388, _polygon389, _polygon390, _polygon391, _polygon392, _polygon393, _polygon394, _polygon395, _polygon396, _polygon397, _rect45, _polygon398, _polygon399, _polygon400, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _polygon401, _polygon402, _rect62, _polygon403, _rect63, _rect64, _rect65, _polygon404, _polygon405, _polygon406, _polygon407, _polygon408, _polygon409, _polygon410, _polygon411, _polygon412, _polygon413, _polygon414, _polygon415, _polygon416, _polygon417, _polygon418, _polygon419, _polygon420, _polygon421, _polygon422, _polygon423, _polygon424, _polygon425, _polygon426, _polygon427, _polygon428, _polygon429, _polygon430, _rect66, _polygon431, _rect67, _rect68, _polygon432, _polygon433, _polygon434, _polygon435, _polygon436, _polygon437, _polygon438, _polygon439, _polygon440, _polygon441, _polygon442, _polygon443, _polygon444, _polygon445, _polygon446, _polygon447, _polygon448, _polygon449, _polygon450, _polygon451, _polygon452, _polygon453, _polygon454, _polygon455, _polygon456, _polygon457, _polygon458, _polygon459, _polygon460, _polygon461, _polygon462, _polygon463, _polygon464, _polygon465, _polygon466, _polygon467, _polygon468, _polygon469, _polygon470, _polygon471, _polygon472, _polygon473, _polygon474, _polygon475, _polygon476, _polygon477, _polygon478, _polygon479, _polygon480, _polygon481, _polygon482, _polygon483, _polygon484, _polygon485, _polygon486, _polygon487, _polygon488, _polygon489, _polygon490, _polygon491, _polygon492, _polygon493, _polygon494, _polygon495, _polygon496, _polygon497, _polygon498, _polygon499, _polygon500, _polygon501, _polygon502, _polygon503, _polygon504, _polygon505, _polygon506, _polygon507, _polygon508, _polygon509, _polygon510, _polygon511, _polygon512, _polygon513, _polygon514, _polygon515, _polygon516, _polygon517, _polygon518, _polygon519, _polygon520, _polygon521, _polygon522, _polygon523, _polygon524, _polygon525, _polygon526, _polygon527, _polygon528, _polygon529, _polygon530, _polygon531, _polygon532, _polygon533, _polygon534, _polygon535, _polygon536, _polygon537, _polygon538, _polygon539, _polygon540, _polygon541, _polygon542, _polygon543, _polygon544, _polygon545, _polygon546, _polygon547, _polygon548, _polygon549, _polygon550, _polygon551, _polygon552, _polygon553, _polygon554, _polygon555, _polygon556, _polygon557, _polygon558, _polygon559, _polygon560, _polygon561, _polygon562, _polygon563, _polygon564, _polygon565, _polygon566, _polygon567, _polygon568, _polygon569, _polygon570, _polygon571, _polygon572, _polygon573, _polygon574, _polygon575, _polygon576, _polygon577, _polygon578, _polygon579, _polygon580, _polygon581, _polygon582, _polygon583, _polygon584, _polygon585, _polygon586, _polygon587, _polygon588, _polygon589, _polygon590, _polygon591, _polygon592, _polygon593, _polygon594, _polygon595, _polygon596, _polygon597, _polygon598, _polygon599, _polygon600, _polygon601, _polygon602, _polygon603, _polygon604, _polygon605, _polygon606, _polygon607, _polygon608, _polygon609, _polygon610, _polygon611, _polygon612, _polygon613, _polygon614, _polygon615, _polygon616, _polygon617, _polygon618, _polygon619, _polygon620, _polygon621, _polygon622, _polygon623, _polygon624, _polygon625, _polygon626, _polygon627, _polygon628, _polygon629, _polygon630, _polygon631, _polygon632, _polygon633, _polygon634, _polygon635, _polygon636, _polygon637, _polygon638, _polygon639, _polygon640, _polygon641, _polygon642, _polygon643, _polygon644, _polygon645, _polygon646, _polygon647, _polygon648, _polygon649, _polygon650, _polygon651, _polygon652, _polygon653, _polygon654, _polygon655, _polygon656, _polygon657, _polygon658, _polygon659, _polygon660, _polygon661, _polygon662, _polygon663, _polygon664, _polygon665, _polygon666, _polygon667, _polygon668, _polygon669, _polygon670, _polygon671, _polygon672, _polygon673, _polygon674, _polygon675, _polygon676, _polygon677, _polygon678, _polygon679, _polygon680, _polygon681, _polygon682, _polygon683, _polygon684, _polygon685, _polygon686, _polygon687, _polygon688, _polygon689, _polygon690, _polygon691, _polygon692, _polygon693, _polygon694, _polygon695, _polygon696, _polygon697, _polygon698, _polygon699, _polygon700, _polygon701, _polygon702, _polygon703, _polygon704, _polygon705, _polygon706, _polygon707, _polygon708, _polygon709, _polygon710, _polygon711, _polygon712, _polygon713, _polygon714, _polygon715, _polygon716, _polygon717, _polygon718, _polygon719, _polygon720, _polygon721, _polygon722, _polygon723, _polygon724, _polygon725, _polygon726, _polygon727, _polygon728, _polygon729, _polygon730, _polygon731, _polygon732, _polygon733, _polygon734, _polygon735, _polygon736, _polygon737, _polygon738, _polygon739, _polygon740, _polygon741, _polygon742, _polygon743, _polygon744, _polygon745, _polygon746, _polygon747, _polygon748, _polygon749, _polygon750, _polygon751, _polygon752, _polygon753, _polygon754, _polygon755, _polygon756, _polygon757, _polygon758, _polygon759, _polygon760, _polygon761, _polygon762, _polygon763, _polygon764;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFamilyProtectionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #800080;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10,17a7,7,0,1,1,7-7A7,7,0,0,1,10,17Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M9.71,6.44l0-.52c0-.74-1.4-.74-1.35,0l0,.52A.65.65,0,0,0,9.71,6.44Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.4,12.75c0-.07-.06-.09-.09-.06l0,0h0v0a.05.05,0,0,0,0,0l-.06,1.4a0,0,0,0,1,0,0h.26s0,0,0,0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.09,7.26l0-.47c0-.65-1.2-.65-1.15,0l0,.47A.54.54,0,0,0,12.09,7.26Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M8.09,11.94l.05,2.13c0,.14.77.16.75,0l0-1.7-.21-.1A6.23,6.23,0,0,1,8.09,11.94Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M9.84,12.69l-.64-.22,0,1.59c0,.08.12.12.31.12h.33v0Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.71,14.07c0,.16.48.14.49,0l.07-1-.58,0Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.82,14.16v0h.36s.24,0,.25-.11l0-1-.6-.09Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.48,12.13l.11,0,.23.06a6.76,6.76,0,0,0,.9.15,5.65,5.65,0,0,0,.92,0,2.77,2.77,0,0,0,.89-.22,2.78,2.78,0,0,1-.89.19h-.33l.1-1.43a3.62,3.62,0,0,0,0-.57l-.08-1.25c0-.09.1-.09.11,0l.15,2.13c.23,0,.32-.11.37-.43l-.11-2c0-.5-.28-.95-.8-.95h-.89a2.5,2.5,0,0,0-.83.19c-.07,0-.09.07-.1.15l0,.29h-.08l0-.36A.23.23,0,0,1,10.3,8l.54-.23-.54-.39a1.24,1.24,0,0,0-.62-.21H8.38a1.07,1.07,0,0,0-1,1.06l0,2.19a.13.13,0,0,0,0,.06l-.2-.17L6.87,10a6.86,6.86,0,0,0,1.41,1.17l.26.15,0,0,0,.06h0l0-.1.13.08.2.11.21.1.42.19.21.08.11.05.1,0,.22.07.22.07Zm1.19-.92,0,1.12-.23,0,0-1.08A.09.09,0,1,1,11.67,11.21ZM9.91,9.77a.39.39,0,0,1,.43-.33.4.4,0,0,1,.44.33,1.35,1.35,0,0,1-.07.49.48.48,0,0,1-.3.2h-.14a.45.45,0,0,1-.29-.2A1.17,1.17,0,0,1,9.91,9.77ZM8.07,8.51l0,1.67,0,.79-.21-.14,0-2.32C7.89,8.42,8.07,8.42,8.07,8.51Zm.88,3v-.61c0-.16.2-.16.21,0l0,.72-.08,0Zm1,.43-.1,0v-.62h0l-.08.57-.2-.08-.06,0,.14-.92a.18.18,0,0,1,.09-.1,1.79,1.79,0,0,1,1.29,0,.18.18,0,0,1,.09.1l.19,1.43s0,0,0,0l-.27,0-.13-1h0v.93h0l-.23-.05-.11,0-.1,0L10.17,12Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.07 9.08 6.01 9.05 6 9.06 6.09 9.13 6.07 9.08"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.03 8.95 6 8.85 5.98 8.91 6.01 8.96 6.03 8.95"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "5.96 8.96 5.86 8.96 5.9 8.99 5.96 8.97 5.96 8.96"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.09 8.96 6.04 9 6.06 9.02 6.15 8.96 6.09 8.96"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "5.95 9.1 5.95 9.03 5.94 9.03 5.91 9.13 5.95 9.1"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "5.87 9.34 5.96 9.4 5.94 9.35 5.88 9.33 5.87 9.34"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "5.78 9.4 5.82 9.37 5.82 9.3 5.81 9.3 5.78 9.4"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "5.77 9.26 5.83 9.24 5.83 9.23 5.72 9.23 5.77 9.26"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "5.9 9.22 5.87 9.13 5.85 9.18 5.88 9.23 5.9 9.22"
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "5.91 9.28 5.92 9.29 6.01 9.23 5.95 9.23 5.91 9.28"
  })), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "5.81 8.63 5.84 8.68 5.86 8.67 5.83 8.58 5.81 8.63"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "5.83 8.79 5.92 8.85 5.9 8.8 5.84 8.78 5.83 8.79"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "5.79 8.69 5.79 8.68 5.69 8.68 5.73 8.71 5.79 8.69"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "5.78 8.75 5.78 8.75 5.74 8.85 5.78 8.82 5.78 8.75"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "5.92 8.68 5.88 8.73 5.89 8.74 5.98 8.68 5.92 8.68"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.5 7.48 6.5 7.48 6.52 7.5 6.52 7.49 6.5 7.48"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.47 7.5 6.48 7.49 6.48 7.47 6.48 7.47 6.47 7.5"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.48 7.45 6.48 7.45 6.45 7.45 6.46 7.46 6.48 7.45"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.54 7.45 6.52 7.45 6.51 7.46 6.51 7.47 6.54 7.45"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.51 7.45 6.5 7.42 6.49 7.43 6.5 7.45 6.51 7.45"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.4 7.55 6.4 7.55 6.43 7.57 6.42 7.55 6.4 7.55"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.39 7.52 6.39 7.52 6.36 7.52 6.37 7.53 6.39 7.52"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.37 7.57 6.38 7.56 6.39 7.54 6.38 7.54 6.37 7.57"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.45 7.52 6.43 7.52 6.42 7.53 6.42 7.54 6.45 7.52"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.41 7.51 6.4 7.49 6.39 7.5 6.4 7.52 6.41 7.51"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.37 7.67 6.4 7.69 6.4 7.67 6.38 7.66 6.37 7.67"
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.34 7.64 6.36 7.63 6.36 7.63 6.32 7.63 6.34 7.64"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.37 7.61 6.38 7.63 6.38 7.63 6.37 7.59 6.37 7.61"
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.35 7.65 6.34 7.69 6.36 7.68 6.36 7.66 6.35 7.65"
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.42 7.63 6.4 7.63 6.39 7.65 6.39 7.65 6.42 7.63"
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.52 7.54 6.51 7.51 6.5 7.53 6.51 7.54 6.52 7.54"
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.52 7.55 6.52 7.55 6.54 7.54 6.53 7.54 6.52 7.55"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 6.49,
    y: 7.56,
    width: 0.02,
    height: 0.01,
    transform: "translate(-1.27 13.81) rotate(-88.14)"
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.53 7.56 6.51 7.56 6.51 7.56 6.53 7.57 6.53 7.56"
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.49 7.54 6.5 7.54 6.5 7.54 6.48 7.54 6.49 7.54"
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.31 7.75 6.33 7.76 6.33 7.75 6.31 7.75 6.31 7.75"
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.3 7.74 6.29 7.76 6.3 7.75 6.3 7.74 6.3 7.74"
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.29 7.73 6.3 7.73 6.3 7.72 6.28 7.72 6.29 7.73"
  })), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.33 7.72 6.32 7.74 6.32 7.74 6.34 7.72 6.33 7.72"
  })), _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.3 7.71 6.31 7.72 6.32 7.72 6.31 7.7 6.3 7.71"
  })), _polygon38 || (_polygon38 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.66 7.44 6.64 7.44 6.65 7.44 6.66 7.44 6.66 7.44"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 6.67,
    y: 7.44,
    width: 0.01,
    height: 0.01,
    transform: "translate(-3.32 7.65) rotate(-49.28)"
  })), _polygon39 || (_polygon39 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.67 7.45 6.68 7.46 6.68 7.46 6.67 7.45 6.67 7.45"
  })), _polygon40 || (_polygon40 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.67 7.44 6.67 7.42 6.66 7.43 6.67 7.44 6.67 7.44"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 6.65,
    y: 7.45,
    width: 0.01,
    transform: "matrix(0.03, -1, 1, 0.03, -1.02, 13.85)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 6.55,
    y: 7.53,
    width: 0.01,
    transform: "translate(-1.19 13.82) rotate(-88.04)"
  })), _polygon41 || (_polygon41 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.57 7.52 6.59 7.51 6.58 7.51 6.57 7.52 6.57 7.52"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 6.54,
    y: 7.51,
    width: 0.01,
    height: 0.01,
    transform: "translate(-1.79 2.05) rotate(-15.67)"
  })), _polygon42 || (_polygon42 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.57 7.53 6.58 7.54 6.58 7.53 6.57 7.53 6.57 7.53"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 6.56,
    y: 7.5,
    width: 0.01,
    height: 0.01,
    transform: "matrix(0.84, -0.54, 0.54, 0.84, -3.01, 4.73)"
  })), _polygon43 || (_polygon43 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.76 7.39 6.76 7.39 6.76 7.38 6.75 7.39 6.76 7.39"
  })), _polygon44 || (_polygon44 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.77 7.4 6.78 7.39 6.77 7.39 6.76 7.4 6.77 7.4"
  })), _polygon45 || (_polygon45 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.76 7.41 6.77 7.42 6.77 7.41 6.76 7.41 6.76 7.41"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 6.74,
    y: 7.39,
    width: 0.01,
    height: 0.01,
    transform: "translate(-1.77 2.14) rotate(-15.95)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 6.74,
    y: 7.41,
    width: 0.01,
    transform: "translate(-2.3 11.73) rotate(-73.19)"
  })), _polygon46 || (_polygon46 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.3 7.56 6.3 7.56 6.28 7.56 6.29 7.57 6.3 7.56"
  })), _polygon47 || (_polygon47 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.34 7.56 6.33 7.56 6.32 7.57 6.32 7.58 6.34 7.56"
  })), _polygon48 || (_polygon48 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.31 7.58 6.31 7.58 6.33 7.6 6.33 7.59 6.31 7.58"
  })), _polygon49 || (_polygon49 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.3 7.59 6.3 7.58 6.3 7.58 6.29 7.6 6.3 7.59"
  })), _polygon50 || (_polygon50 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.32 7.56 6.31 7.54 6.31 7.55 6.31 7.56 6.32 7.56"
  })), _polygon51 || (_polygon51 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.01 7.87 6.01 7.87 5.99 7.87 6 7.88 6.01 7.87"
  })), _polygon52 || (_polygon52 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.03 7.89 6.02 7.89 6.02 7.89 6.04 7.91 6.03 7.89"
  })), _polygon53 || (_polygon53 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.03 7.87 6.02 7.85 6.01 7.86 6.02 7.87 6.03 7.87"
  })), _polygon54 || (_polygon54 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.05 7.87 6.04 7.87 6.03 7.88 6.03 7.88 6.05 7.87"
  })), _polygon55 || (_polygon55 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.01 7.88 6 7.91 6.01 7.9 6.01 7.88 6.01 7.88"
  })), _polygon56 || (_polygon56 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.44 7.61 6.44 7.6 6.44 7.6 6.43 7.62 6.44 7.61"
  })), _polygon57 || (_polygon57 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.46 7.59 6.46 7.6 6.48 7.58 6.47 7.58 6.46 7.59"
  })), _polygon58 || (_polygon58 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.44 7.58 6.44 7.58 6.42 7.58 6.43 7.59 6.44 7.58"
  })), _polygon59 || (_polygon59 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.45 7.58 6.46 7.58 6.45 7.56 6.45 7.57 6.45 7.58"
  })), _polygon60 || (_polygon60 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.45 7.61 6.47 7.62 6.46 7.61 6.45 7.6 6.45 7.61"
  })), _polygon61 || (_polygon61 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.21 9.33 6.28 9.38 6.27 9.34 6.22 9.32 6.21 9.33"
  })), _polygon62 || (_polygon62 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.18 9.26 6.18 9.24 6.09 9.25 6.13 9.27 6.18 9.26"
  })), _polygon63 || (_polygon63 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.22 9.24 6.24 9.24 6.21 9.16 6.2 9.21 6.22 9.24"
  })), _polygon64 || (_polygon64 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.17 9.36 6.17 9.3 6.17 9.3 6.14 9.38 6.17 9.36"
  })), _polygon65 || (_polygon65 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.25 9.28 6.25 9.29 6.33 9.24 6.28 9.24 6.25 9.28"
  })), _polygon66 || (_polygon66 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "5.78 8.32 5.78 8.32 5.76 8.38 5.78 8.36 5.78 8.32"
  })), _polygon67 || (_polygon67 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "5.83 8.27 5.81 8.21 5.8 8.25 5.82 8.28 5.83 8.27"
  })), _polygon68 || (_polygon68 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "5.81 8.34 5.81 8.34 5.86 8.38 5.85 8.35 5.81 8.34"
  })), _polygon69 || (_polygon69 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "5.78 8.28 5.78 8.28 5.72 8.28 5.75 8.29 5.78 8.28"
  })), _polygon70 || (_polygon70 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "5.9 8.28 5.86 8.28 5.84 8.3 5.84 8.31 5.9 8.28"
  })), _polygon71 || (_polygon71 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "5.75 9.14 5.75 9.1 5.74 9.1 5.72 9.16 5.75 9.14"
  })), _polygon72 || (_polygon72 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "5.78 9.11 5.78 9.12 5.83 9.16 5.82 9.13 5.78 9.11"
  })), _polygon73 || (_polygon73 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "5.79 9.05 5.8 9.05 5.78 8.99 5.79 9.01 5.79 8.99 5.76 8.98 5.76 8.98 5.78 8.99 5.77 9.03 5.79 9.05"
  })), _polygon74 || (_polygon74 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "5.75 9.05 5.69 9.05 5.72 9.07 5.75 9.06 5.75 9.05"
  })), _polygon75 || (_polygon75 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "5.87 9.05 5.83 9.05 5.8 9.08 5.81 9.09 5.87 9.05"
  })), _polygon76 || (_polygon76 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.04 8.6 6.01 8.59 6 8.59 6.04 8.62 6.04 8.6"
  })), _polygon77 || (_polygon77 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "5.96 8.56 5.99 8.55 5.99 8.54 5.94 8.55 5.96 8.56"
  })), _polygon78 || (_polygon78 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "5.98 8.58 5.98 8.58 5.96 8.62 5.98 8.61 5.98 8.58"
  })), _polygon79 || (_polygon79 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.02 8.54 6 8.5 6 8.52 6.01 8.54 6.02 8.54"
  })), _polygon80 || (_polygon80 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.04 8.54 6.03 8.57 6.03 8.57 6.07 8.55 6.04 8.54"
  })), _polygon81 || (_polygon81 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "5.9 8.44 5.9 8.43 5.83 8.43 5.86 8.45 5.9 8.44"
  })), _polygon82 || (_polygon82 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "5.89 8.52 5.89 8.48 5.89 8.47 5.87 8.54 5.89 8.52"
  })), _polygon83 || (_polygon83 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "5.92 8.5 5.97 8.54 5.97 8.51 5.93 8.49 5.92 8.5"
  })), _polygon84 || (_polygon84 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "5.91 8.4 5.93 8.43 5.94 8.43 5.92 8.37 5.91 8.4"
  })), _polygon85 || (_polygon85 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "5.96 8.47 6.01 8.43 5.97 8.43 5.95 8.46 5.96 8.47"
  })), _polygon86 || (_polygon86 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6 8.11 6.03 8.1 6.03 8.09 5.97 8.1 6 8.11"
  })), _polygon87 || (_polygon87 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.06 8.15 6.06 8.16 6.11 8.2 6.1 8.17 6.06 8.15"
  })), _polygon88 || (_polygon88 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.08 8.12 6.09 8.13 6.14 8.1 6.11 8.09 6.08 8.12"
  })), _polygon89 || (_polygon89 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.03 8.14 6.02 8.14 6 8.2 6.03 8.18 6.03 8.14"
  })), _polygon90 || (_polygon90 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.05 8.07 6.07 8.09 6.08 8.09 6.06 8.03 6.05 8.07"
  })), _polygon91 || (_polygon91 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.21 7.76 6.17 7.76 6.15 7.79 6.15 7.8 6.21 7.76"
  })), _polygon92 || (_polygon92 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.14 7.76 6.12 7.7 6.11 7.73 6.13 7.76 6.14 7.76"
  })), _polygon93 || (_polygon93 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.09 7.77 6.09 7.76 6.03 7.76 6.06 7.78 6.09 7.77"
  })), _polygon94 || (_polygon94 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.07 7.86 6.09 7.85 6.09 7.8 6.09 7.8 6.07 7.86"
  })), _polygon95 || (_polygon95 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.13 7.82 6.12 7.83 6.17 7.86 6.17 7.83 6.13 7.82"
  })), _polygon96 || (_polygon96 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.61 7.41 6.59 7.37 6.59 7.4 6.6 7.42 6.61 7.41"
  })), _polygon97 || (_polygon97 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.66 7.42 6.63 7.42 6.62 7.44 6.62 7.45 6.66 7.42"
  })), _polygon98 || (_polygon98 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.63 7.47 6.6 7.46 6.59 7.46 6.63 7.49 6.63 7.47"
  })), _polygon99 || (_polygon99 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.58 7.42 6.58 7.42 6.53 7.42 6.55 7.43 6.58 7.42"
  })), _polygon100 || (_polygon100 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.57 7.45 6.57 7.45 6.56 7.49 6.57 7.48 6.57 7.45"
  })), _polygon101 || (_polygon101 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.74 9.89 6.66 9.89 6.61 9.95 6.63 9.97 6.74 9.89"
  })), _polygon102 || (_polygon102 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.5 9.98 6.49 9.97 6.45 10.1 6.49 10.07 6.5 9.98"
  })), _polygon103 || (_polygon103 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.65 10.04 6.57 10.01 6.55 10.02 6.67 10.1 6.65 10.04"
  })), _polygon104 || (_polygon104 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.5 9.89 6.38 9.89 6.43 9.93 6.5 9.9 6.5 9.89"
  })), _polygon105 || (_polygon105 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.59 9.88 6.56 9.76 6.53 9.83 6.57 9.88 6.59 9.88"
  })), _polygon106 || (_polygon106 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.14 10.44 7.1 10.31 7.08 10.38 7.12 10.44 7.14 10.44"
  })), _polygon107 || (_polygon107 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.04 10.54 7.03 10.53 6.99 10.66 7.04 10.62 7.04 10.54"
  })), _polygon108 || (_polygon108 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.11 10.57 7.1 10.58 7.21 10.66 7.19 10.6 7.11 10.57"
  })), _polygon109 || (_polygon109 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.21 10.44 7.16 10.5 7.17 10.52 7.28 10.45 7.21 10.44"
  })), _polygon110 || (_polygon110 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.97 10.48 7.05 10.46 7.05 10.44 6.92 10.45 6.97 10.48"
  })), _polygon111 || (_polygon111 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.41 10.67 7.43 10.71 7.45 10.71 7.42 10.63 7.41 10.67"
  })), _polygon112 || (_polygon112 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.42 10.8 7.49 10.85 7.48 10.81 7.43 10.79 7.42 10.8"
  })), _polygon113 || (_polygon113 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.37 10.77 7.35 10.85 7.38 10.83 7.38 10.77 7.37 10.77"
  })), _polygon114 || (_polygon114 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.33 10.74 7.38 10.72 7.38 10.71 7.3 10.71 7.33 10.74"
  })), _polygon115 || (_polygon115 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.46 10.75 7.47 10.76 7.54 10.71 7.49 10.71 7.46 10.75"
  })), _polygon116 || (_polygon116 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.61 11.34 7.58 11.26 7.57 11.3 7.59 11.34 7.61 11.34"
  })), _polygon117 || (_polygon117 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.59 11.42 7.58 11.43 7.66 11.48 7.65 11.44 7.59 11.42"
  })), _polygon118 || (_polygon118 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.5 11.37 7.55 11.35 7.55 11.34 7.46 11.34 7.5 11.37"
  })), _polygon119 || (_polygon119 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.51 11.48 7.54 11.46 7.54 11.4 7.54 11.4 7.51 11.48"
  })), _polygon120 || (_polygon120 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.62 11.38 7.63 11.39 7.71 11.34 7.66 11.34 7.62 11.38"
  })), _polygon121 || (_polygon121 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "8.06 11.17 8.09 11.21 8.1 11.2 8.08 11.12 8.06 11.17"
  })), _polygon122 || (_polygon122 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "8.08 11.3 8.15 11.35 8.14 11.31 8.09 11.29 8.08 11.3"
  })), _polygon123 || (_polygon123 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "8.12 11.25 8.12 11.26 8.2 11.21 8.15 11.21 8.12 11.25"
  })), _polygon124 || (_polygon124 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "8.04 11.32 8.04 11.27 8.03 11.26 8.01 11.35 8.04 11.32"
  })), _polygon125 || (_polygon125 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "8.04 11.21 7.96 11.21 7.99 11.23 8.04 11.22 8.04 11.21"
  })), _polygon126 || (_polygon126 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.94 11.49 7.88 11.47 7.88 11.48 7.95 11.54 7.94 11.49"
  })), _polygon127 || (_polygon127 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.9 11.39 7.88 11.31 7.86 11.35 7.89 11.39 7.9 11.39"
  })), _polygon128 || (_polygon128 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.92 11.43 7.92 11.45 8 11.39 7.95 11.39 7.92 11.43"
  })), _polygon129 || (_polygon129 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.79 11.42 7.84 11.4 7.84 11.39 7.76 11.39 7.79 11.42"
  })), _polygon130 || (_polygon130 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.8 11.54 7.84 11.51 7.84 11.45 7.83 11.45 7.8 11.54"
  })), _polygon131 || (_polygon131 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "9.73 12.48 9.68 12.46 9.67 12.47 9.74 12.52 9.73 12.48"
  })), _polygon132 || (_polygon132 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "9.63 12.49 9.63 12.44 9.62 12.43 9.6 12.52 9.63 12.49"
  })), _polygon133 || (_polygon133 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "9.63 12.38 9.55 12.38 9.58 12.4 9.63 12.39 9.63 12.38"
  })), _polygon134 || (_polygon134 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "9.65 12.34 9.68 12.37 9.7 12.37 9.67 12.29 9.65 12.34"
  })), _polygon135 || (_polygon135 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "9.71 12.42 9.71 12.43 9.79 12.38 9.74 12.38 9.71 12.42"
  })), _polygon136 || (_polygon136 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.78 10.78 6.85 10.76 6.85 10.74 6.73 10.74 6.78 10.78"
  })), _polygon137 || (_polygon137 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.94 10.73 6.91 10.61 6.88 10.68 6.92 10.74 6.94 10.73"
  })), _polygon138 || (_polygon138 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.96 10.8 6.97 10.82 7.08 10.74 7.01 10.74 6.96 10.8"
  })), _polygon139 || (_polygon139 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.92 10.86 6.9 10.87 7.01 10.95 7 10.89 6.92 10.86"
  })), _polygon140 || (_polygon140 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.8 10.95 6.85 10.91 6.85 10.83 6.84 10.82 6.8 10.95"
  })), _polygon141 || (_polygon141 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "9.76 12.02 9.79 12.07 9.81 12.06 9.78 11.95 9.76 12.02"
  })), _polygon142 || (_polygon142 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "9.88 12.07 9.83 12.13 9.84 12.15 9.95 12.07 9.88 12.07"
  })), _polygon143 || (_polygon143 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "9.78 12.2 9.88 12.28 9.87 12.22 9.79 12.19 9.78 12.2"
  })), _polygon144 || (_polygon144 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "9.65 12.11 9.72 12.09 9.72 12.07 9.6 12.07 9.65 12.11"
  })), _polygon145 || (_polygon145 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "9.72 12.16 9.71 12.16 9.67 12.28 9.72 12.25 9.72 12.16"
  })), _polygon146 || (_polygon146 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "8.42 11.46 8.49 11.44 8.49 11.42 8.37 11.42 8.42 11.46"
  })), _polygon147 || (_polygon147 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "8.6 11.48 8.61 11.49 8.72 11.42 8.65 11.42 8.6 11.48"
  })), _polygon148 || (_polygon148 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "8.54 11.55 8.65 11.62 8.63 11.56 8.55 11.54 8.54 11.55"
  })), _polygon149 || (_polygon149 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "8.48 11.5 8.44 11.62 8.48 11.59 8.49 11.51 8.48 11.5"
  })), _polygon150 || (_polygon150 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "10.54 12.29 10.57 12.35 10.6 12.34 10.56 12.22 10.54 12.29"
  })), _polygon151 || (_polygon151 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "10.5 12.44 10.49 12.43 10.45 12.55 10.5 12.52 10.5 12.44"
  })), _polygon152 || (_polygon152 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "10.57 12.47 10.56 12.48 10.66 12.55 10.65 12.5 10.57 12.47"
  })), _polygon153 || (_polygon153 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "10.63 12.43 10.73 12.35 10.66 12.35 10.61 12.41 10.63 12.43"
  })), _polygon154 || (_polygon154 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "10.51 12.35 10.38 12.35 10.43 12.38 10.51 12.37 10.51 12.35"
  })), _polygon155 || (_polygon155 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "10.85 12.74 10.84 12.74 10.8 12.86 10.85 12.83 10.85 12.74"
  })), _polygon156 || (_polygon156 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "11 12.8 10.92 12.77 10.91 12.79 11.01 12.86 11 12.8"
  })), _polygon157 || (_polygon157 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "10.86 12.66 10.73 12.66 10.78 12.69 10.86 12.67 10.86 12.66"
  })), _polygon158 || (_polygon158 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "10.92 12.65 10.95 12.65 10.91 12.53 10.89 12.6 10.92 12.65"
  })), _polygon159 || (_polygon159 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "11.01 12.66 10.96 12.71 10.97 12.73 11.08 12.66 11.01 12.66"
  })), _polygon160 || (_polygon160 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.29 11.09 7.27 11.1 7.4 11.2 7.38 11.13 7.29 11.09"
  })), _polygon161 || (_polygon161 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.12 10.99 7.21 10.97 7.21 10.95 7.06 10.95 7.12 10.99"
  })), _polygon162 || (_polygon162 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.32 10.94 7.27 10.79 7.25 10.88 7.29 10.94 7.32 10.94"
  })), _polygon163 || (_polygon163 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.14 11.2 7.2 11.16 7.2 11.05 7.19 11.05 7.14 11.2"
  })), _polygon164 || (_polygon164 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.34 11.02 7.36 11.04 7.49 10.95 7.4 10.95 7.34 11.02"
  })), _polygon165 || (_polygon165 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.3 9.68 6.3 9.68 6.28 9.74 6.3 9.73 6.3 9.68"
  })), _polygon166 || (_polygon166 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.31 9.64 6.31 9.63 6.24 9.63 6.27 9.65 6.31 9.64"
  })), _polygon167 || (_polygon167 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.33 9.7 6.39 9.74 6.38 9.71 6.34 9.7 6.33 9.7"
  })), _polygon168 || (_polygon168 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.37 9.68 6.43 9.63 6.39 9.63 6.37 9.66 6.37 9.68"
  })), _polygon169 || (_polygon169 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.34 9.63 6.36 9.63 6.34 9.56 6.32 9.6 6.34 9.63"
  })), _polygon170 || (_polygon170 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "8.32 11.3 8.29 11.33 8.3 11.34 8.36 11.3 8.32 11.3"
  })), _polygon171 || (_polygon171 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "8.2 11.32 8.24 11.31 8.24 11.3 8.17 11.3 8.2 11.32"
  })), _polygon172 || (_polygon172 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "8.23 11.35 8.23 11.34 8.21 11.41 8.23 11.39 8.23 11.35"
  })), _polygon173 || (_polygon173 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "8.26 11.37 8.32 11.41 8.31 11.38 8.27 11.36 8.26 11.37"
  })), _polygon174 || (_polygon174 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "8.25 11.27 8.27 11.3 8.29 11.29 8.26 11.23 8.25 11.27"
  })), _polygon175 || (_polygon175 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.49 9.75 6.49 9.72 6.48 9.72 6.47 9.76 6.49 9.75"
  })), _polygon176 || (_polygon176 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.46 9.71 6.49 9.7 6.49 9.7 6.45 9.7 6.46 9.71"
  })), _polygon177 || (_polygon177 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.52 9.69 6.51 9.65 6.5 9.68 6.51 9.7 6.52 9.69"
  })), _polygon178 || (_polygon178 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.54 9.74 6.51 9.73 6.5 9.74 6.54 9.76 6.54 9.74"
  })), _polygon179 || (_polygon179 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.52 9.71 6.53 9.72 6.56 9.7 6.54 9.7 6.52 9.71"
  })), _polygon180 || (_polygon180 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.08 8.74 6.07 8.7 6.06 8.72 6.07 8.74 6.08 8.74"
  })), _polygon181 || (_polygon181 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.09 8.79 6.07 8.78 6.06 8.78 6.1 8.81 6.09 8.79"
  })), _polygon182 || (_polygon182 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.05 8.74 6.01 8.74 6.02 8.75 6.05 8.75 6.05 8.74"
  })), _polygon183 || (_polygon183 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.1 8.74 6.08 8.76 6.09 8.77 6.12 8.74 6.1 8.74"
  })), _polygon184 || (_polygon184 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.04 8.8 6.05 8.77 6.04 8.77 6.03 8.81 6.04 8.8"
  })), _polygon185 || (_polygon185 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "5.76 8.52 5.76 8.52 5.72 8.52 5.74 8.53 5.76 8.52"
  })), _polygon186 || (_polygon186 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "5.78 8.56 5.78 8.56 5.81 8.59 5.81 8.57 5.78 8.56"
  })), _polygon187 || (_polygon187 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "5.83 8.52 5.81 8.52 5.79 8.54 5.8 8.54 5.83 8.52"
  })), _polygon188 || (_polygon188 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "5.77 8.5 5.78 8.52 5.79 8.52 5.78 8.48 5.77 8.5"
  })), _polygon189 || (_polygon189 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "5.76 8.57 5.76 8.55 5.75 8.55 5.74 8.59 5.76 8.57"
  })), _polygon190 || (_polygon190 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "5.74 8.99 5.74 8.97 5.74 8.96 5.72 9.01 5.74 8.99"
  })), _polygon191 || (_polygon191 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "5.77 8.94 5.76 8.9 5.75 8.92 5.76 8.94 5.77 8.94"
  })), _polygon192 || (_polygon192 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "5.79 8.94 5.78 8.96 5.78 8.96 5.82 8.94 5.79 8.94"
  })), _polygon193 || (_polygon193 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "5.74 8.94 5.7 8.94 5.72 8.95 5.74 8.94 5.74 8.94"
  })), _polygon194 || (_polygon194 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "5.88 8.12 5.88 8.12 5.84 8.12 5.86 8.13 5.88 8.12"
  })), _polygon195 || (_polygon195 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "5.88 8.17 5.88 8.14 5.88 8.14 5.87 8.18 5.88 8.17"
  })), _polygon196 || (_polygon196 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "5.91 8.11 5.9 8.07 5.89 8.1 5.91 8.12 5.91 8.11"
  })), _polygon197 || (_polygon197 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "5.9 8.15 5.9 8.16 5.94 8.18 5.93 8.16 5.9 8.15"
  })), _polygon198 || (_polygon198 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "5.92 8.13 5.92 8.14 5.96 8.12 5.93 8.12 5.92 8.13"
  })), _polygon199 || (_polygon199 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.16 7.98 6.14 7.97 6.13 7.98 6.17 8 6.16 7.98"
  })), _polygon200 || (_polygon200 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.14 7.93 6.13 7.89 6.13 7.92 6.14 7.93 6.14 7.93"
  })), _polygon201 || (_polygon201 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.09 7.95 6.12 7.94 6.12 7.93 6.08 7.94 6.09 7.95"
  })), _polygon202 || (_polygon202 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.17 7.93 6.15 7.95 6.15 7.96 6.19 7.94 6.17 7.93"
  })), _polygon203 || (_polygon203 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.11 7.96 6.11 7.96 6.1 8 6.11 7.99 6.11 7.96"
  })), _polygon204 || (_polygon204 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "5.97 7.97 6.01 8 6 7.98 5.98 7.97 5.97 7.97"
  })), _polygon205 || (_polygon205 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "5.96 7.94 5.96 7.93 5.92 7.93 5.93 7.95 5.96 7.94"
  })), _polygon206 || (_polygon206 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "5.99 7.93 5.97 7.89 5.97 7.91 5.98 7.93 5.99 7.93"
  })), _polygon207 || (_polygon207 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6 7.96 6.03 7.93 6.01 7.93 5.99 7.95 6 7.96"
  })), _polygon208 || (_polygon208 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "5.95 7.96 5.94 8 5.96 7.99 5.96 7.96 5.95 7.96"
  })), _polygon209 || (_polygon209 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.23 7.67 6.23 7.67 6.22 7.71 6.23 7.7 6.23 7.67"
  })), _polygon210 || (_polygon210 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.31 7.64 6.29 7.64 6.27 7.66 6.28 7.67 6.31 7.64"
  })), _polygon211 || (_polygon211 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.24 7.65 6.24 7.64 6.2 7.64 6.21 7.65 6.24 7.65"
  })), _polygon212 || (_polygon212 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.26 7.64 6.25 7.6 6.25 7.62 6.26 7.64 6.26 7.64"
  })), _polygon213 || (_polygon213 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.26 7.68 6.25 7.68 6.29 7.71 6.28 7.69 6.26 7.68"
  })), _polygon214 || (_polygon214 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7 7.29 6.98 7.27 6.98 7.27 7 7.3 7 7.29"
  })), _polygon215 || (_polygon215 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7 7.24 7 7.21 6.99 7.23 6.99 7.24 7 7.24"
  })), _polygon216 || (_polygon216 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.96 7.26 6.95 7.29 6.96 7.28 6.97 7.26 6.96 7.26"
  })), _polygon217 || (_polygon217 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.97 7.24 6.97 7.24 6.94 7.23 6.95 7.24 6.97 7.24"
  })), _polygon218 || (_polygon218 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7 7.27 7.03 7.25 7.01 7.25 7 7.26 7 7.27"
  })), _polygon219 || (_polygon219 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.89 7.3 6.92 7.29 6.9 7.29 6.89 7.3 6.89 7.3"
  })), _polygon220 || (_polygon220 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.86 7.3 6.85 7.3 6.84 7.32 6.85 7.32 6.86 7.3"
  })), _polygon221 || (_polygon221 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.86 7.28 6.86 7.28 6.83 7.27 6.84 7.28 6.86 7.28"
  })), _polygon222 || (_polygon222 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.89 7.32 6.87 7.31 6.87 7.31 6.89 7.34 6.89 7.32"
  })), _polygon223 || (_polygon223 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.89 7.28 6.88 7.25 6.88 7.27 6.88 7.28 6.89 7.28"
  })), _polygon224 || (_polygon224 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.83 7.34 6.83 7.31 6.82 7.33 6.83 7.34 6.83 7.34"
  })), _polygon225 || (_polygon225 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.83 7.38 6.82 7.37 6.81 7.37 6.83 7.39 6.83 7.38"
  })), _polygon226 || (_polygon226 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.83 7.36 6.86 7.35 6.84 7.35 6.83 7.36 6.83 7.36"
  })), _polygon227 || (_polygon227 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.8 7.36 6.78 7.38 6.8 7.38 6.8 7.36 6.8 7.36"
  })), _polygon228 || (_polygon228 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.79 7.3 6.79 7.28 6.78 7.29 6.78 7.3 6.79 7.3"
  })), _polygon229 || (_polygon229 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.79 7.33 6.79 7.34 6.81 7.34 6.81 7.34 6.79 7.33 6.79 7.33 6.78 7.32 6.77 7.32 6.79 7.34 6.79 7.33"
  })), _polygon230 || (_polygon230 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.79 7.32 6.81 7.31 6.8 7.3 6.79 7.31 6.79 7.32"
  })), _polygon231 || (_polygon231 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.76 7.31 6.75 7.33 6.76 7.33 6.76 7.31 6.76 7.31"
  })), _polygon232 || (_polygon232 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.77 7.3 6.77 7.3 6.75 7.29 6.76 7.3 6.77 7.3"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 6.91,
    y: 7.33,
    width: 0.02,
    height: 0.01,
    transform: "translate(-2.21 11.62) rotate(-71.8)"
  })), _polygon233 || (_polygon233 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.95 7.33 6.97 7.33 6.96 7.32 6.95 7.33 6.95 7.33"
  })), _polygon234 || (_polygon234 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.95 7.32 6.95 7.3 6.94 7.31 6.95 7.32 6.95 7.32"
  })), _polygon235 || (_polygon235 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.93 7.31 6.91 7.31 6.92 7.32 6.93 7.32 6.93 7.31"
  })), _polygon236 || (_polygon236 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.95 7.35 6.94 7.34 6.94 7.34 6.95 7.36 6.95 7.35"
  })), _polygon237 || (_polygon237 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.65 7.42 6.67 7.41 6.67 7.38 6.67 7.38 6.65 7.42"
  })), _polygon238 || (_polygon238 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.68 7.36 6.68 7.36 6.64 7.34 6.66 7.36 6.68 7.36"
  })), _polygon239 || (_polygon239 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.71 7.39 6.75 7.38 6.73 7.37 6.71 7.38 6.71 7.39"
  })), _polygon240 || (_polygon240 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.71 7.36 6.71 7.32 6.7 7.34 6.71 7.36 6.71 7.36"
  })), _polygon241 || (_polygon241 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.71 7.41 6.69 7.4 6.69 7.4 6.71 7.43 6.71 7.41"
  })), _polygon242 || (_polygon242 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.22 7.2 7.21 7.19 7.21 7.19 7.22 7.21 7.22 7.2"
  })), _polygon243 || (_polygon243 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.22 7.17 7.22 7.14 7.21 7.15 7.22 7.17 7.22 7.17"
  })), _polygon244 || (_polygon244 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.2 7.18 7.2 7.18 7.18 7.2 7.19 7.2 7.2 7.18"
  })), _polygon245 || (_polygon245 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.2 7.17 7.21 7.16 7.18 7.15 7.19 7.16 7.2 7.17"
  })), _polygon246 || (_polygon246 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.22 7.19 7.25 7.18 7.24 7.17 7.22 7.18 7.22 7.19"
  })), _polygon247 || (_polygon247 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.13 7.22 7.12 7.21 7.11 7.21 7.13 7.24 7.13 7.22"
  })), _polygon248 || (_polygon248 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.13 7.19 7.13 7.17 7.12 7.18 7.13 7.19 7.13 7.19"
  })), _polygon249 || (_polygon249 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.11 7.2 7.11 7.2 7.09 7.22 7.1 7.22 7.11 7.2"
  })), _polygon250 || (_polygon250 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.11 7.19 7.11 7.19 7.09 7.18 7.1 7.19 7.11 7.19"
  })), _polygon251 || (_polygon251 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.13 7.21 7.16 7.2 7.14 7.2 7.13 7.21 7.13 7.21"
  })), _polygon252 || (_polygon252 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.06 7.29 7.08 7.32 7.08 7.3 7.06 7.29 7.06 7.29"
  })), _polygon253 || (_polygon253 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.06 7.26 7.03 7.25 7.04 7.26 7.06 7.26 7.06 7.26"
  })), _polygon254 || (_polygon254 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.08 7.28 7.08 7.29 7.11 7.28 7.09 7.28 7.08 7.28"
  })), _polygon255 || (_polygon255 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.04 7.3 7.05 7.28 7.05 7.28 7.03 7.3 7.04 7.3"
  })), _polygon256 || (_polygon256 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.08 7.27 7.08 7.24 7.07 7.25 7.07 7.27 7.08 7.27"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 7.18,
    y: 7.23,
    width: 0.01,
    height: 0.01,
    transform: "translate(-2.23 11.14) rotate(-67.75)"
  })), _polygon257 || (_polygon257 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.21 7.22 7.2 7.23 7.2 7.24 7.21 7.24 7.21 7.22"
  })), _polygon258 || (_polygon258 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.22 7.24 7.21 7.24 7.2 7.25 7.21 7.25 7.22 7.24"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 7.18,
    y: 7.25,
    width: 0.01,
    transform: "translate(-3.01 7.65) rotate(-47.49)"
  })), _polygon259 || (_polygon259 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.19 7.25 7.2 7.27 7.2 7.26 7.2 7.25 7.19 7.25"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 7.33,
    y: 7.21,
    width: 0.01,
    transform: "translate(-2.19 11.12) rotate(-66.84)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 7.35,
    y: 7.21,
    width: 0.01,
    height: 0.01,
    transform: "translate(-2.07 11.37) rotate(-68.27)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 7.35,
    y: 7.2,
    width: 0.01,
    height: 0.01,
    transform: "translate(-2.84 8.6) rotate(-52.25)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 7.34,
    y: 7.22,
    height: 0.01,
    transform: "translate(-2.92 8.03) rotate(-48.99)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 7.33,
    y: 7.2,
    height: 0.01,
    transform: "translate(-1.94 11.65) rotate(-70.09)"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 7.23,
    y: 7.24,
    width: 0.01,
    transform: "translate(-2.31 10.93) rotate(-66.16)"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 7.24,
    y: 7.22,
    height: 0.01,
    transform: "translate(-2.01 11.61) rotate(-70.29)"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 7.25,
    y: 7.22,
    width: 0.01,
    height: 0.01,
    transform: "translate(-2.9 8.58) rotate(-52.48)"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 7.25,
    y: 7.24,
    width: 0.01,
    height: 0.01,
    transform: "translate(-2.13 11.36) rotate(-68.6)"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 7.25,
    y: 7.24,
    height: 0.01,
    transform: "translate(-2.98 7.96) rotate(-48.99)"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 7.41,
    y: 7.21,
    width: 0.01,
    transform: "translate(-2.13 11.19) rotate(-66.84)"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 7.42,
    y: 7.21,
    height: 0.01,
    transform: "translate(-2.89 8.16) rotate(-49.4)"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 7.41,
    y: 7.19,
    height: 0.01,
    transform: "translate(-1.84 11.78) rotate(-70.49)"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 7.43,
    y: 7.2,
    width: 0.01,
    height: 0.01,
    transform: "translate(-1.52 2) rotate(-13.94)"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 7.43,
    y: 7.19,
    width: 0.01,
    height: 0.01,
    transform: "translate(-0.54 13.78) rotate(-83.66)"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 7.03,
    y: 7.19,
    width: 0.01,
    height: 0.01,
    transform: "translate(-2.4 10.7) rotate(-66.04)"
  })), _polygon260 || (_polygon260 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.05 7.21 7.07 7.21 7.06 7.2 7.05 7.21 7.05 7.21"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 7.02,
    y: 7.21,
    width: 0.01,
    transform: "translate(-2.99 8.25) rotate(-51.63)"
  })), _polygon261 || (_polygon261 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.05 7.2 7.05 7.18 7.04 7.19 7.05 7.2 7.05 7.2"
  })), _polygon262 || (_polygon262 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.05 7.23 7.05 7.22 7.04 7.21 7.04 7.21 7.05 7.23"
  })), _polygon263 || (_polygon263 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.13 7.25 7.12 7.24 7.12 7.25 7.13 7.25 7.13 7.25"
  })), _polygon264 || (_polygon264 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.15 7.24 7.14 7.24 7.14 7.25 7.15 7.25 7.15 7.24"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 7.12,
    y: 7.27,
    width: 0.01,
    transform: "matrix(0.39, -0.92, 0.92, 0.39, -2.33, 11.03)"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 7.14,
    y: 7.27,
    width: 0.01,
    height: 0.02,
    transform: "translate(-3.03 7.95) rotate(-49.35)"
  })), _polygon265 || (_polygon265 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.17 7.26 7.16 7.26 7.15 7.26 7.15 7.27 7.17 7.26"
  })), _polygon266 || (_polygon266 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.31 7.2 7.35 7.19 7.33 7.18 7.31 7.19 7.31 7.2"
  })), _polygon267 || (_polygon267 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.28 7.17 7.29 7.17 7.25 7.15 7.26 7.17 7.28 7.17"
  })), _polygon268 || (_polygon268 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.31 7.17 7.31 7.14 7.3 7.15 7.3 7.17 7.31 7.17"
  })), _polygon269 || (_polygon269 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.31 7.24 7.31 7.22 7.29 7.2 7.29 7.21 7.31 7.24"
  })), _polygon270 || (_polygon270 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.27 7.19 7.25 7.22 7.26 7.21 7.27 7.19 7.27 7.19"
  })), _polygon271 || (_polygon271 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.63 7.15 7.63 7.14 7.61 7.13 7.62 7.14 7.63 7.15"
  })), _polygon272 || (_polygon272 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.66 7.13 7.65 7.14 7.64 7.15 7.65 7.16 7.66 7.13"
  })), _polygon273 || (_polygon273 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.63 7.17 7.63 7.2 7.64 7.19 7.63 7.17 7.63 7.17"
  })), _polygon274 || (_polygon274 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.66 7.16 7.64 7.17 7.64 7.17 7.67 7.17 7.66 7.16"
  })), _polygon275 || (_polygon275 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.62 7.16 7.62 7.16 7.6 7.17 7.61 7.17 7.62 7.16"
  })), _polygon276 || (_polygon276 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.54 7.14 7.54 7.14 7.52 7.13 7.52 7.14 7.54 7.14"
  })), _polygon277 || (_polygon277 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.56 7.13 7.55 7.14 7.55 7.15 7.56 7.15 7.56 7.13"
  })), _polygon278 || (_polygon278 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.57 7.16 7.55 7.17 7.55 7.17 7.58 7.17 7.57 7.16"
  })), _polygon279 || (_polygon279 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.53 7.16 7.53 7.15 7.51 7.17 7.52 7.17 7.53 7.16"
  })), _polygon280 || (_polygon280 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.53 7.17 7.54 7.2 7.54 7.18 7.54 7.17 7.53 7.17"
  })), _polygon281 || (_polygon281 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.47 7.2 7.48 7.22 7.49 7.21 7.48 7.2 7.47 7.2"
  })), _polygon282 || (_polygon282 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.5 7.16 7.49 7.17 7.49 7.18 7.5 7.18 7.5 7.16"
  })), _polygon283 || (_polygon283 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.51 7.19 7.49 7.19 7.49 7.2 7.52 7.2 7.51 7.19"
  })), _polygon284 || (_polygon284 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.46 7.2 7.47 7.18 7.47 7.18 7.45 7.2 7.46 7.2"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 7.44,
    y: 7.14,
    width: 0.01,
    transform: "translate(-2.74 5.51) rotate(-34.7)"
  })), _polygon285 || (_polygon285 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.46 7.15 7.46 7.15 7.46 7.17 7.47 7.16 7.47 7.17 7.48 7.17 7.48 7.17 7.47 7.16 7.47 7.16 7.46 7.15"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 7.45,
    y: 7.12,
    width: 0.01,
    height: 0.01,
    transform: "translate(-2.79 8.29) rotate(-50.19)"
  })), _polygon286 || (_polygon286 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.48 7.12 7.47 7.13 7.47 7.13 7.47 7.14 7.48 7.12"
  })), _polygon287 || (_polygon287 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.48 7.14 7.47 7.15 7.47 7.15 7.49 7.15 7.48 7.14"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 7.57,
    y: 7.18,
    width: 0.01,
    height: 0.01,
    transform: "translate(-1.85 11.67) rotate(-68.94)"
  })), _polygon288 || (_polygon288 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.6 7.18 7.59 7.19 7.59 7.2 7.59 7.2 7.6 7.18"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 7.56,
    y: 7.2,
    width: 0.01,
    transform: "translate(-2.8 8.53) rotate(-50.91)"
  })), _polygon289 || (_polygon289 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.58 7.21 7.58 7.23 7.59 7.22 7.58 7.21 7.58 7.21"
  })), _polygon290 || (_polygon290 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.6 7.2 7.59 7.21 7.59 7.21 7.61 7.21 7.6 7.2"
  })), _polygon291 || (_polygon291 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.42 7.17 7.4 7.18 7.4 7.18 7.43 7.18 7.42 7.17"
  })), _polygon292 || (_polygon292 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.41 7.13 7.4 7.14 7.4 7.16 7.4 7.16 7.41 7.13"
  })), _polygon293 || (_polygon293 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.37 7.18 7.38 7.22 7.39 7.2 7.38 7.18 7.37 7.18"
  })), _polygon294 || (_polygon294 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.38 7.15 7.38 7.15 7.36 7.13 7.36 7.14 7.38 7.15"
  })), _polygon295 || (_polygon295 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.37 7.17 7.37 7.16 7.34 7.18 7.35 7.18 7.37 7.17"
  })), _polygon296 || (_polygon296 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.26 7.81 6.28 7.79 6.26 7.79 6.25 7.8 6.26 7.81"
  })), _polygon297 || (_polygon297 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.22 7.8 6.23 7.8 6.23 7.79 6.21 7.79 6.22 7.8"
  })), _polygon298 || (_polygon298 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.24 7.82 6.26 7.83 6.26 7.82 6.25 7.82 6.24 7.82"
  })), _polygon299 || (_polygon299 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.23 7.83 6.23 7.81 6.23 7.81 6.22 7.83 6.23 7.83"
  })), _polygon300 || (_polygon300 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.25 7.79 6.24 7.77 6.24 7.78 6.25 7.79 6.25 7.79"
  })), _polygon301 || (_polygon301 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.8 9.76 13.8 9.74 13.78 9.77 13.78 9.77 13.8 9.76"
  })), _polygon302 || (_polygon302 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.83 9.79 13.8 9.78 13.8 9.78 13.81 9.79 13.83 9.79"
  })), _polygon303 || (_polygon303 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.76 9.79 13.77 9.78 13.76 9.77 13.74 9.76 13.76 9.79"
  })), _polygon304 || (_polygon304 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.79 9.8 13.79 9.82 13.8 9.84 13.8 9.8 13.79 9.8"
  })), _polygon305 || (_polygon305 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.74 9.82 13.78 9.81 13.77 9.8 13.75 9.8 13.74 9.82"
  })), _polygon306 || (_polygon306 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.87 9.9 13.87 9.9 13.86 9.92 13.87 9.93 13.87 9.9"
  })), _polygon307 || (_polygon307 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.9 9.89 13.87 9.88 13.87 9.88 13.89 9.89 13.9 9.89"
  })), _polygon308 || (_polygon308 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.81 9.91 13.85 9.9 13.85 9.9 13.82 9.9 13.81 9.91"
  })), _polygon309 || (_polygon309 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.87 9.86 13.87 9.84 13.85 9.87 13.86 9.87 13.87 9.86"
  })), _polygon310 || (_polygon310 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.84 9.89 13.84 9.88 13.83 9.86 13.81 9.86 13.84 9.89"
  })), _polygon311 || (_polygon311 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.83 10.02 13.81 10.02 13.8 10.04 13.84 10.03 13.83 10.02"
  })), _polygon312 || (_polygon312 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.82 10.01 13.83 10 13.82 9.98 13.8 9.97 13.82 10.01"
  })), _polygon313 || (_polygon313 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.9 10.01 13.86 10 13.86 10 13.88 10.01 13.9 10.01"
  })), _polygon314 || (_polygon314 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.86 10.02 13.85 10.05 13.86 10.06 13.86 10.02 13.86 10.02"
  })), _polygon315 || (_polygon315 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.85 9.99 13.86 9.98 13.86 9.96 13.84 9.98 13.85 9.99"
  })), _polygon316 || (_polygon316 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.74 9.88 13.73 9.88 13.72 9.88 13.71 9.88 13.74 9.88"
  })), _polygon317 || (_polygon317 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.75 9.86 13.76 9.87 13.78 9.87 13.75 9.86 13.75 9.86"
  })), _polygon318 || (_polygon318 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.73 9.86 13.73 9.85 13.71 9.85 13.73 9.86 13.73 9.86"
  })), _polygon319 || (_polygon319 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.75 9.83 13.74 9.85 13.74 9.85 13.75 9.85 13.75 9.83"
  })), _polygon320 || (_polygon320 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.75 9.9 13.75 9.87 13.75 9.87 13.74 9.89 13.75 9.9"
  })), _polygon321 || (_polygon321 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.89 10.08 13.87 10.1 13.88 10.1 13.89 10.1 13.89 10.08"
  })), _polygon322 || (_polygon322 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.88 10.15 13.89 10.12 13.88 10.12 13.88 10.14 13.88 10.15"
  })), _polygon323 || (_polygon323 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.86 10.11 13.87 10.11 13.86 10.1 13.85 10.1 13.86 10.11"
  })), _polygon324 || (_polygon324 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.89 10.11 13.9 10.12 13.91 10.12 13.89 10.11 13.89 10.11"
  })), _polygon325 || (_polygon325 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.87 10.12 13.86 10.12 13.85 10.13 13.87 10.13 13.87 10.12"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 13.62,
    y: 9.69,
    width: 0.01,
    transform: "translate(0.92 20.56) rotate(-75.96)"
  })), _polygon326 || (_polygon326 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.63 9.67 13.63 9.67 13.63 9.66 13.62 9.67 13.63 9.67"
  })), _polygon327 || (_polygon327 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.61 9.67 13.61 9.66 13.61 9.68 13.62 9.68 13.61 9.67"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 13.6,
    y: 9.68,
    width: 0.01,
    height: 0.01,
    transform: "translate(-0.49 0.73) rotate(-3.02)"
  })), _polygon328 || (_polygon328 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.63 9.68 13.64 9.69 13.65 9.69 13.63 9.68 13.63 9.68"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 13.65,
    y: 9.8,
    width: 0.01,
    height: 0.01,
    transform: "translate(-0.47 0.69) rotate(-2.85)"
  })), _polygon329 || (_polygon329 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.66 9.78 13.65 9.78 13.66 9.79 13.66 9.79 13.66 9.78"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 13.67,
    y: 9.78,
    width: 0.01,
    height: 0.01,
    transform: "translate(-3.08 11.15) rotate(-40.24)"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 13.68,
    y: 9.79,
    width: 0.01,
    height: 0.01,
    transform: "translate(-1.92 16.11) rotate(-57.63)"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 13.66,
    y: 9.81,
    width: 0.01,
    transform: "translate(0.72 20.55) rotate(-75.32)"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 13.58,
    y: 9.59,
    width: 0.01,
    height: 0.01,
    transform: "translate(-1.8 15.93) rotate(-57.63)"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 13.55,
    y: 9.6,
    width: 0.01,
    height: 0.01,
    transform: "translate(-0.46 0.69) rotate(-2.86)"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 13.56,
    y: 9.61,
    width: 0.01,
    transform: "translate(0.84 20.3) rotate(-75.32)"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 13.55,
    y: 9.58,
    width: 0.01,
    height: 0.01,
    transform: "translate(-2.69 6.15) rotate(-23.32)"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 13.57,
    y: 9.58,
    width: 0.01,
    height: 0.01,
    transform: "translate(-2.97 11.1) rotate(-40.45)"
  })), _polygon330 || (_polygon330 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.96 9.96 13.94 9.95 13.94 9.95 13.95 9.96 13.96 9.96"
  })), _polygon331 || (_polygon331 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.92 9.96 13.92 9.95 13.91 9.94 13.9 9.94 13.92 9.96"
  })), _polygon332 || (_polygon332 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.9 9.97 13.93 9.97 13.92 9.96 13.91 9.96 13.9 9.97"
  })), _polygon333 || (_polygon333 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.94 9.96 13.93 9.98 13.94 9.99 13.94 9.96 13.94 9.96"
  })), _polygon334 || (_polygon334 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.94 9.94 13.94 9.92 13.93 9.94 13.93 9.94 13.94 9.94"
  })), _polygon335 || (_polygon335 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.8 9.9 13.78 9.92 13.79 9.92 13.79 9.91 13.8 9.9"
  })), _polygon336 || (_polygon336 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.82 9.93 13.8 9.92 13.8 9.93 13.81 9.93 13.82 9.93"
  })), _polygon337 || (_polygon337 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.77 9.93 13.78 9.93 13.77 9.91 13.76 9.91 13.77 9.93"
  })), _polygon338 || (_polygon338 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.79 9.94 13.79 9.94 13.79 9.95 13.79 9.96 13.79 9.94"
  })), _polygon339 || (_polygon339 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.78 9.94 13.76 9.94 13.76 9.95 13.78 9.94 13.78 9.94"
  })), _polygon340 || (_polygon340 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.07 10.26 14.07 10.26 14.05 10.3 14.07 10.32 14.07 10.26"
  })), _polygon341 || (_polygon341 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.01 10.23 14.02 10.22 14 10.19 13.97 10.17 14.01 10.23"
  })), _polygon342 || (_polygon342 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.97 10.28 14.03 10.27 14.03 10.26 13.98 10.26 13.97 10.28"
  })), _polygon343 || (_polygon343 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.14 10.23 14.08 10.21 14.08 10.22 14.11 10.24 14.14 10.23"
  })), _polygon344 || (_polygon344 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.07 10.18 14.08 10.14 14.04 10.19 14.05 10.2 14.07 10.18"
  })), _polygon345 || (_polygon345 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.67 9.73 13.64 9.72 13.62 9.74 13.67 9.73 13.67 9.73"
  })), _polygon346 || (_polygon346 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.67 9.7 13.66 9.67 13.64 9.66 13.66 9.7 13.67 9.7"
  })), _polygon347 || (_polygon347 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.69 9.69 13.71 9.68 13.72 9.65 13.69 9.68 13.69 9.69"
  })), _polygon348 || (_polygon348 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.7 9.73 13.68 9.76 13.69 9.78 13.7 9.73 13.7 9.73"
  })), _polygon349 || (_polygon349 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.71 9.71 13.73 9.73 13.75 9.73 13.71 9.7 13.71 9.71"
  })), _polygon350 || (_polygon350 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.95 10.08 13.95 10.08 13.92 10.08 13.91 10.1 13.95 10.08"
  })), _polygon351 || (_polygon351 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.91 10.02 13.93 10.06 13.94 10.05 13.93 10.03 13.91 10.02"
  })), _polygon352 || (_polygon352 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.02 10.06 13.98 10.05 13.98 10.05 14 10.07 14.02 10.06"
  })), _polygon353 || (_polygon353 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.96 10.1 13.97 10.12 13.98 10.08 13.97 10.08 13.96 10.1"
  })), _polygon354 || (_polygon354 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.96 10.04 13.98 10.03 13.98 10 13.95 10.04 13.96 10.04"
  })), _polygon355 || (_polygon355 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.44 9.37 13.42 9.37 13.41 9.38 13.45 9.37 13.44 9.37"
  })), _polygon356 || (_polygon356 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.44 9.35 13.43 9.33 13.41 9.33 13.43 9.35 13.44 9.35"
  })), _polygon357 || (_polygon357 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.46 9.39 13.47 9.4 13.46 9.36 13.46 9.37 13.46 9.39"
  })), _polygon358 || (_polygon358 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.45 9.34 13.46 9.33 13.46 9.31 13.45 9.33 13.45 9.34"
  })), _polygon359 || (_polygon359 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.5 9.35 13.47 9.34 13.47 9.35 13.48 9.36 13.5 9.35"
  })), _polygon360 || (_polygon360 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.49 9.47 13.52 9.46 13.52 9.46 13.5 9.46 13.49 9.47"
  })), _polygon361 || (_polygon361 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.54 9.42 13.54 9.4 13.52 9.43 13.53 9.43 13.54 9.42"
  })), _polygon362 || (_polygon362 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.51 9.44 13.51 9.44 13.5 9.42 13.48 9.42 13.51 9.44"
  })), _polygon363 || (_polygon363 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.53 9.48 13.54 9.49 13.54 9.46 13.54 9.46 13.53 9.48"
  })), _polygon364 || (_polygon364 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.57 9.44 13.54 9.43 13.54 9.44 13.56 9.45 13.57 9.44"
  })), _polygon365 || (_polygon365 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.54 9.51 13.54 9.51 13.55 9.5 13.55 9.48 13.54 9.51"
  })), _polygon366 || (_polygon366 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.53 9.54 13.52 9.54 13.51 9.55 13.54 9.54 13.53 9.54"
  })), _polygon367 || (_polygon367 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.53 9.52 13.52 9.5 13.5 9.5 13.52 9.52 13.53 9.52"
  })), _polygon368 || (_polygon368 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.55 9.53 13.55 9.55 13.55 9.56 13.55 9.53 13.55 9.53"
  })), _polygon369 || (_polygon369 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.61 9.49 13.61 9.47 13.6 9.49 13.6 9.5 13.61 9.49"
  })), _polygon370 || (_polygon370 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.58 9.52 13.56 9.51 13.55 9.52 13.57 9.53 13.58 9.52 13.57 9.53 13.6 9.52 13.59 9.52 13.58 9.52 13.58 9.52"
  })), _polygon371 || (_polygon371 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.59 9.5 13.58 9.49 13.57 9.49 13.59 9.51 13.59 9.5"
  })), _polygon372 || (_polygon372 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.6 9.53 13.61 9.54 13.61 9.51 13.61 9.51 13.6 9.53"
  })), _polygon373 || (_polygon373 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.63 9.51 13.61 9.5 13.61 9.5 13.62 9.51 13.63 9.51"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 13.46,
    y: 9.44,
    width: 0.01,
    height: 0.02,
    transform: "translate(-0.84 1.32) rotate(-5.44)"
  })), _polygon374 || (_polygon374 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.44 9.43 13.44 9.42 13.42 9.42 13.44 9.44 13.44 9.43"
  })), _polygon375 || (_polygon375 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.45 9.45 13.43 9.45 13.43 9.46 13.45 9.45 13.45 9.45"
  })), _polygon376 || (_polygon376 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.46 9.43 13.47 9.44 13.48 9.43 13.46 9.43 13.46 9.43"
  })), _polygon377 || (_polygon377 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.46 9.42 13.46 9.4 13.45 9.42 13.45 9.43 13.46 9.42"
  })), _polygon378 || (_polygon378 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.64 9.65 13.65 9.66 13.65 9.62 13.65 9.62 13.64 9.65"
  })), _polygon379 || (_polygon379 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.62 9.6 13.6 9.58 13.58 9.57 13.61 9.61 13.62 9.6"
  })), _polygon380 || (_polygon380 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.62 9.63 13.6 9.63 13.59 9.64 13.63 9.63 13.62 9.63"
  })), _polygon381 || (_polygon381 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.69 9.61 13.65 9.59 13.65 9.6 13.67 9.61 13.69 9.61"
  })), _polygon382 || (_polygon382 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.63 9.59 13.65 9.57 13.65 9.55 13.63 9.58 13.63 9.59"
  })), _polygon383 || (_polygon383 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.31 9.14 13.3 9.13 13.29 9.15 13.3 9.15 13.31 9.14"
  })), _polygon384 || (_polygon384 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.28 9.17 13.29 9.16 13.28 9.15 13.27 9.15 13.28 9.17"
  })), _polygon385 || (_polygon385 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.29 9.18 13.28 9.18 13.27 9.19 13.29 9.18 13.29 9.18"
  })), _polygon386 || (_polygon386 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.34 9.16 13.31 9.16 13.31 9.16 13.32 9.17 13.34 9.16"
  })), _polygon387 || (_polygon387 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.31 9.2 13.31 9.17 13.31 9.17 13.31 9.19 13.31 9.2"
  })), _polygon388 || (_polygon388 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.36 9.25 13.34 9.25 13.34 9.26 13.36 9.25 13.36 9.25"
  })), _polygon389 || (_polygon389 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.4 9.23 13.38 9.22 13.38 9.23 13.39 9.23 13.4 9.23"
  })), _polygon390 || (_polygon390 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.35 9.23 13.35 9.23 13.34 9.22 13.33 9.22 13.35 9.23"
  })), _polygon391 || (_polygon391 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.38 9.27 13.38 9.24 13.37 9.24 13.37 9.26 13.38 9.27"
  })), _polygon392 || (_polygon392 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.37 9.21 13.37 9.2 13.36 9.22 13.36 9.22 13.37 9.21"
  })), _polygon393 || (_polygon393 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.41 9.32 13.38 9.32 13.38 9.32 13.4 9.33 13.41 9.32"
  })), _polygon394 || (_polygon394 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.38 9.34 13.38 9.34 13.38 9.36 13.39 9.37 13.38 9.34"
  })), _polygon395 || (_polygon395 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.36 9.33 13.35 9.31 13.33 9.31 13.35 9.33 13.36 9.33"
  })), _polygon396 || (_polygon396 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.36 9.34 13.34 9.35 13.34 9.36 13.37 9.35 13.36 9.34"
  })), _polygon397 || (_polygon397 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.38 9.3 13.38 9.29 13.36 9.31 13.37 9.31 13.38 9.3"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 13.28,
    y: 9.23,
    height: 0.01,
    transform: "translate(-1.04 1.72) rotate(-7.13)"
  })), _polygon398 || (_polygon398 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.28 9.21 13.28 9.2 13.27 9.22 13.28 9.22 13.28 9.21"
  })), _polygon399 || (_polygon399 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.27 9.23 13.26 9.22 13.25 9.22 13.27 9.23 13.27 9.23"
  })), _polygon400 || (_polygon400 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.27 9.24 13.26 9.24 13.26 9.25 13.27 9.24 13.27 9.24"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 13.29,
    y: 9.22,
    width: 0.01,
    height: 0.01,
    transform: "translate(1.52 20.32) rotate(-78.06)"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 13.17,
    y: 9.13,
    height: 0.01,
    transform: "translate(-0.91 1.47) rotate(-6.18)"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 13.15,
    y: 9.11,
    width: 0.01,
    height: 0.01,
    transform: "translate(-2.51 12.42) rotate(-46.64)"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 13.16,
    y: 9.11,
    width: 0.01,
    height: 0.01,
    transform: "translate(-0.86 1.39) rotate(-5.86)"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 13.15,
    y: 9.13,
    width: 0.01,
    transform: "translate(-2.56 6.07) rotate(-23.74)"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 13.18,
    y: 9.12,
    height: 0.01,
    transform: "translate(1.54 20.14) rotate(-78.11)"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 13.22,
    y: 9.19,
    width: 0.01,
    height: 0.01,
    transform: "translate(-2.81 7.65) rotate(-29.32)"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 13.24,
    y: 9.2,
    height: 0.01,
    transform: "translate(-0.72 1.13) rotate(-4.76)"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 13.23,
    y: 9.18,
    width: 0.01,
    height: 0.01,
    transform: "translate(-0.87 1.4) rotate(-5.86)"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 13.25,
    y: 9.19,
    height: 0.01,
    transform: "matrix(0.21, -0.98, 0.98, 0.21, 1.52, 20.26)"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 13.22,
    y: 9.2,
    width: 0.01,
    transform: "translate(-1.32 2.27) rotate(-9.36)"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 13.11,
    y: 9.08,
    height: 0.01,
    transform: "translate(-0.96 1.58) rotate(-6.64)"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 13.1,
    y: 9.06,
    width: 0.01,
    height: 0.01,
    transform: "translate(-2.51 12.23) rotate(-46.12)"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 13.11,
    y: 9.07,
    height: 0.01,
    transform: "translate(-2.51 5.9) rotate(-23.2)"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 13.09,
    y: 9.08,
    width: 0.01,
    transform: "matrix(0.99, -0.16, 0.16, 0.99, -1.3, 2.25)"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 13.09,
    y: 9.07,
    width: 0.01,
    height: 0.01,
    transform: "translate(-2.78 7.74) rotate(-29.91)"
  })), _polygon401 || (_polygon401 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.42 9.29 13.41 9.29 13.41 9.3 13.43 9.29 13.42 9.29"
  })), _polygon402 || (_polygon402 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.43 9.26 13.43 9.25 13.42 9.27 13.43 9.27 13.43 9.26"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 13.43,
    y: 9.28,
    height: 0.01,
    transform: "matrix(0.99, -0.1, 0.1, 0.99, -0.89, 1.44)"
  })), _polygon403 || (_polygon403 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.42 9.28 13.41 9.27 13.4 9.27 13.42 9.28 13.42 9.28"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 13.44,
    y: 9.27,
    width: 0.01,
    height: 0.01,
    transform: "translate(1.59 20.51) rotate(-78.06)"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 13.33,
    y: 9.26,
    width: 0.01,
    height: 0.01,
    transform: "translate(1.52 20.41) rotate(-78.13)"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 13.32,
    y: 9.28,
    height: 0.01,
    transform: "translate(-1.05 1.72) rotate(-7.13)"
  })), _polygon404 || (_polygon404 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.32 9.26 13.32 9.25 13.31 9.26 13.31 9.27 13.32 9.26"
  })), _polygon405 || (_polygon405 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.31 9.28 13.3 9.28 13.3 9.29 13.31 9.29 13.31 9.28"
  })), _polygon406 || (_polygon406 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.31 9.27 13.3 9.26 13.29 9.26 13.31 9.28 13.31 9.27"
  })), _polygon407 || (_polygon407 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.18 9.1 13.2 9.13 13.21 9.13 13.2 9.11 13.18 9.1"
  })), _polygon408 || (_polygon408 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.28 9.12 13.24 9.12 13.24 9.12 13.26 9.13 13.28 9.12"
  })), _polygon409 || (_polygon409 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.22 9.15 13.19 9.15 13.19 9.17 13.22 9.15 13.22 9.15"
  })), _polygon410 || (_polygon410 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.25 9.18 13.24 9.14 13.24 9.14 13.23 9.17 13.25 9.18"
  })), _polygon411 || (_polygon411 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.24 9.1 13.23 9.08 13.22 9.11 13.22 9.11 13.24 9.1"
  })), _polygon412 || (_polygon412 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "12.95 8.9 12.94 8.89 12.94 8.92 12.94 8.92 12.95 8.9"
  })), _polygon413 || (_polygon413 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "12.93 8.95 12.93 8.96 12.95 8.94 12.94 8.94 12.93 8.95"
  })), _polygon414 || (_polygon414 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "12.93 8.93 12.92 8.92 12.91 8.92 12.93 8.93 12.93 8.93"
  })), _polygon415 || (_polygon415 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "12.96 8.93 12.96 8.93 12.96 8.95 12.97 8.96 12.96 8.93"
  })), _polygon416 || (_polygon416 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "12.97 8.92 12.98 8.91 12.96 8.92 12.96 8.92 12.97 8.92"
  })), _polygon417 || (_polygon417 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.01 9 13.01 9.01 13.03 8.99 13.03 8.99 13.01 9"
  })), _polygon418 || (_polygon418 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.05 8.97 13.06 8.96 13.04 8.96 13.04 8.97 13.05 8.97"
  })), _polygon419 || (_polygon419 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.05 9 13.04 8.98 13.04 8.98 13.04 9 13.05 9"
  })), _polygon420 || (_polygon420 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.02 8.98 13.01 8.97 12.99 8.97 13.01 8.98 13.02 8.98"
  })), _polygon421 || (_polygon421 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.03 8.95 13.02 8.94 13.02 8.96 13.02 8.96 13.03 8.95"
  })), _polygon422 || (_polygon422 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.09 9.02 13.09 9.02 13.09 9.02 13.1 9.01 13.1 9.01 13.09 9.02 13.09 9.02 13.07 9.02 13.07 9.02 13.09 9.02"
  })), _polygon423 || (_polygon423 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.07 9.04 13.07 9.05 13.08 9.06 13.07 9.03 13.07 9.04"
  })), _polygon424 || (_polygon424 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.06 9.04 13.05 9.05 13.04 9.06 13.06 9.04 13.06 9.04"
  })), _polygon425 || (_polygon425 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.06 8.99 13.05 9.02 13.06 9.02 13.06 9.01 13.06 8.99"
  })), _polygon426 || (_polygon426 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.05 9.03 13.04 9.02 13.03 9.02 13.05 9.04 13.05 9.03"
  })), _polygon427 || (_polygon427 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.1 8.98 13.1 8.98 13.1 8.99 13.1 8.99 13.1 8.98"
  })), _polygon428 || (_polygon428 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.12 9 13.13 8.99 13.11 8.99 13.11 8.99 13.12 9"
  })), _polygon429 || (_polygon429 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.09 9 13.09 8.99 13.07 9 13.09 9.01 13.09 9"
  })), _polygon430 || (_polygon430 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.11 9.02 13.12 9.02 13.11 9 13.11 9.01 13.11 9.02"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 12.97,
    y: 9,
    width: 0.01,
    transform: "translate(-1.35 15.64) rotate(-59.59)"
  })), _polygon431 || (_polygon431 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "12.97 8.96 12.96 8.98 12.97 8.98 12.97 8.97 12.97 8.96"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 12.96,
    y: 9,
    width: 0.02,
    height: 0.01,
    transform: "translate(-2.75 10.5) rotate(-40.23)"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 12.98,
    y: 8.98,
    width: 0.01,
    height: 0.01,
    transform: "translate(-0.64 1.01) rotate(-4.34)"
  })), _polygon432 || (_polygon432 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "12.96 8.99 12.96 8.99 12.95 8.98 12.94 8.98 12.96 8.99"
  })), _polygon433 || (_polygon433 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.13 9.09 13.13 9.11 13.16 9.09 13.15 9.08 13.13 9.09"
  })), _polygon434 || (_polygon434 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.16 9.04 13.15 9.02 13.14 9.05 13.15 9.05 13.16 9.04"
  })), _polygon435 || (_polygon435 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.19 9.06 13.2 9.05 13.17 9.05 13.17 9.06 13.19 9.06"
  })), _polygon436 || (_polygon436 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.14 9.07 13.13 9.05 13.11 9.06 13.14 9.07 13.14 9.07"
  })), _polygon437 || (_polygon437 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.17 9.07 13.17 9.07 13.17 9.1 13.19 9.1 13.17 9.07"
  })), _polygon438 || (_polygon438 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.93 10.24 13.93 10.21 13.93 10.21 13.92 10.23 13.93 10.24"
  })), _polygon439 || (_polygon439 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.93 10.17 13.91 10.19 13.92 10.19 13.93 10.18 13.93 10.17"
  })), _polygon440 || (_polygon440 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.93 10.2 13.94 10.21 13.96 10.21 13.93 10.2 13.93 10.2"
  })), _polygon441 || (_polygon441 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.91 10.22 13.89 10.22 13.89 10.23 13.91 10.22 13.91 10.22"
  })), _polygon442 || (_polygon442 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.9 10.2 13.91 10.2 13.9 10.19 13.89 10.18 13.9 10.2"
  })), _polygon443 || (_polygon443 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.02 8.27 6.03 8.28 6.04 8.28 6.03 8.24 6.02 8.27"
  })), _polygon444 || (_polygon444 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "5.99 8.3 6.01 8.29 6.01 8.28 5.97 8.29 5.99 8.3"
  })), _polygon445 || (_polygon445 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.05 8.31 6.08 8.29 6.06 8.29 6.04 8.3 6.05 8.31"
  })), _polygon446 || (_polygon446 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.03 8.33 6.06 8.35 6.05 8.33 6.03 8.32 6.03 8.33"
  })), _polygon447 || (_polygon447 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.01 8.34 6.01 8.31 6 8.31 5.99 8.35 6.01 8.34"
  })), _polygon448 || (_polygon448 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.46 10.19 6.44 10.2 6.44 10.21 6.48 10.19 6.46 10.19"
  })), _polygon449 || (_polygon449 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.41 10.19 6.37 10.19 6.38 10.2 6.41 10.19 6.41 10.19"
  })), _polygon450 || (_polygon450 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.4 10.21 6.4 10.21 6.39 10.25 6.4 10.24 6.4 10.21"
  })), _polygon451 || (_polygon451 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.45 10.23 6.42 10.22 6.42 10.23 6.46 10.25 6.45 10.23"
  })), _polygon452 || (_polygon452 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.43 10.18 6.42 10.14 6.42 10.17 6.43 10.18 6.43 10.18"
  })), _polygon453 || (_polygon453 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.12 9.84 6.11 9.8 6.1 9.83 6.12 9.85 6.12 9.84"
  })), _polygon454 || (_polygon454 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.14 9.89 6.12 9.88 6.11 9.89 6.15 9.91 6.14 9.89"
  })), _polygon455 || (_polygon455 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.07 9.86 6.09 9.85 6.09 9.85 6.05 9.85 6.07 9.86"
  })), _polygon456 || (_polygon456 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.08 9.91 6.09 9.9 6.09 9.87 6.09 9.87 6.08 9.91"
  })), _polygon457 || (_polygon457 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.13 9.87 6.17 9.85 6.14 9.85 6.13 9.86 6.13 9.87"
  })), _polygon458 || (_polygon458 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.29 10.3 6.3 10.29 6.3 10.27 6.3 10.27 6.29 10.3"
  })), _polygon459 || (_polygon459 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.28 10.25 6.3 10.25 6.3 10.24 6.27 10.24 6.28 10.25"
  })), _polygon460 || (_polygon460 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.33 10.26 6.33 10.27 6.36 10.24 6.34 10.24 6.33 10.26"
  })), _polygon461 || (_polygon461 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.33 10.24 6.32 10.21 6.31 10.23 6.32 10.24 6.33 10.24"
  })), _polygon462 || (_polygon462 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.32 10.28 6.31 10.28 6.34 10.3 6.34 10.28 6.32 10.28"
  })), _polygon463 || (_polygon463 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.35 9.81 6.33 9.84 6.33 9.84 6.38 9.81 6.35 9.81"
  })), _polygon464 || (_polygon464 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.28 9.89 6.28 9.85 6.27 9.85 6.25 9.9 6.28 9.89"
  })), _polygon465 || (_polygon465 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.28 9.82 6.28 9.81 6.22 9.81 6.25 9.83 6.28 9.82"
  })), _polygon466 || (_polygon466 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.32 9.81 6.3 9.75 6.29 9.78 6.31 9.81 6.32 9.81"
  })), _polygon467 || (_polygon467 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.34 9.88 6.31 9.86 6.3 9.87 6.35 9.9 6.34 9.88"
  })), _polygon468 || (_polygon468 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.31 10.12 6.26 10.1 6.25 10.11 6.33 10.16 6.31 10.12"
  })), _polygon469 || (_polygon469 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.37 10.03 6.32 10.03 6.29 10.06 6.3 10.08 6.37 10.03"
  })), _polygon470 || (_polygon470 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.17 10.05 6.22 10.04 6.22 10.03 6.14 10.03 6.17 10.05"
  })), _polygon471 || (_polygon471 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.28 10.02 6.25 9.94 6.24 9.99 6.26 10.03 6.28 10.02"
  })), _polygon472 || (_polygon472 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.19 10.16 6.21 10.14 6.22 10.08 6.21 10.08 6.19 10.16"
  })), _polygon473 || (_polygon473 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.85 10.12 6.83 10.06 6.82 10.09 6.84 10.12 6.85 10.12"
  })), _polygon474 || (_polygon474 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.8 10.22 6.8 10.17 6.79 10.17 6.77 10.24 6.8 10.22"
  })), _polygon475 || (_polygon475 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.86 10.16 6.87 10.17 6.92 10.13 6.88 10.13 6.86 10.16"
  })), _polygon476 || (_polygon476 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.88 10.21 6.83 10.19 6.83 10.2 6.89 10.24 6.88 10.21"
  })), _polygon477 || (_polygon477 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.76 10.14 6.8 10.13 6.8 10.13 6.74 10.13 6.76 10.14"
  })), _polygon478 || (_polygon478 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.2 9.52 6.14 9.59 6.15 9.62 6.29 9.52 6.2 9.52"
  })), _polygon479 || (_polygon479 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "5.92 9.57 6.01 9.54 6.01 9.52 5.86 9.52 5.92 9.57"
  })), _polygon480 || (_polygon480 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.12 9.51 6.07 9.37 6.04 9.45 6.09 9.52 6.12 9.51"
  })), _polygon481 || (_polygon481 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "5.94 9.77 6 9.73 6 9.63 5.99 9.63 5.94 9.77"
  })), _polygon482 || (_polygon482 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.18 9.7 6.08 9.67 6.07 9.68 6.2 9.77 6.18 9.7"
  })), _polygon483 || (_polygon483 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.35 10.92 14.34 10.92 14.39 10.96 14.38 10.93 14.35 10.92"
  })), _polygon484 || (_polygon484 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.33 10.83 14.35 10.86 14.36 10.86 14.34 10.8 14.33 10.83"
  })), _polygon485 || (_polygon485 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.28 10.88 14.32 10.87 14.32 10.86 14.26 10.86 14.28 10.88"
  })), _polygon486 || (_polygon486 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.38 10.9 14.43 10.86 14.39 10.86 14.37 10.89 14.38 10.9"
  })), _polygon487 || (_polygon487 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.31 10.9 14.29 10.96 14.31 10.94 14.32 10.9 14.31 10.9"
  })), _polygon488 || (_polygon488 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.23 10.74 14.22 10.75 14.31 10.81 14.3 10.76 14.23 10.74"
  })), _polygon489 || (_polygon489 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.12 10.67 14.18 10.65 14.18 10.64 14.08 10.64 14.12 10.67"
  })), _polygon490 || (_polygon490 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.21 10.59 14.24 10.64 14.26 10.63 14.23 10.54 14.21 10.59"
  })), _polygon491 || (_polygon491 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.17 10.71 14.14 10.81 14.18 10.78 14.18 10.71 14.17 10.71"
  })), _polygon492 || (_polygon492 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.37 10.64 14.31 10.64 14.27 10.69 14.28 10.7 14.37 10.64"
  })), _polygon493 || (_polygon493 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.32 11.15 14.27 11.14 14.27 11.14 14.33 11.19 14.32 11.15"
  })), _polygon494 || (_polygon494 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.23 11.17 14.23 11.12 14.23 11.12 14.21 11.19 14.23 11.17"
  })), _polygon495 || (_polygon495 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.2 11.09 14.24 11.08 14.24 11.07 14.17 11.07 14.2 11.09"
  })), _polygon496 || (_polygon496 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.3 11.1 14.31 11.11 14.37 11.07 14.33 11.07 14.3 11.1"
  })), _polygon497 || (_polygon497 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.29 11.06 14.27 11 14.26 11.04 14.28 11.07 14.29 11.06"
  })), _polygon498 || (_polygon498 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.05 10.37 14.07 10.39 14.08 10.38 14.06 10.34 14.05 10.37"
  })), _polygon499 || (_polygon499 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.06 10.44 14.1 10.46 14.1 10.44 14.07 10.43 14.06 10.44"
  })), _polygon500 || (_polygon500 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.1 10.39 14.08 10.41 14.09 10.42 14.13 10.39 14.1 10.39"
  })), _polygon501 || (_polygon501 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.04 10.42 14.04 10.42 14.02 10.46 14.04 10.45 14.04 10.42"
  })), _polygon502 || (_polygon502 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.04 10.39 14 10.39 14.02 10.4 14.04 10.39 14.04 10.39"
  })), _polygon503 || (_polygon503 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.17 10.45 14.16 10.45 14.15 10.49 14.17 10.48 14.17 10.45"
  })), _polygon504 || (_polygon504 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.14 10.43 14.17 10.43 14.17 10.42 14.13 10.42 14.14 10.43"
  })), _polygon505 || (_polygon505 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.2 10.42 14.19 10.38 14.18 10.4 14.19 10.42 14.2 10.42"
  })), _polygon506 || (_polygon506 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.21 10.47 14.19 10.46 14.19 10.46 14.22 10.49 14.21 10.47"
  })), _polygon507 || (_polygon507 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.24 10.42 14.22 10.42 14.2 10.44 14.21 10.45 14.24 10.42"
  })), _polygon508 || (_polygon508 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.25 10.92 14.24 10.94 14.24 10.95 14.28 10.92 14.25 10.92"
  })), _polygon509 || (_polygon509 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.21 10.9 14.22 10.92 14.23 10.92 14.22 10.88 14.21 10.9"
  })), _polygon510 || (_polygon510 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.18 10.93 14.2 10.93 14.2 10.92 14.16 10.92 14.18 10.93"
  })), _polygon511 || (_polygon511 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.22 10.96 14.26 10.99 14.25 10.97 14.22 10.96 14.22 10.96"
  })), _polygon512 || (_polygon512 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.2 10.95 14.19 10.99 14.2 10.98 14.2 10.95 14.2 10.95"
  })), _polygon513 || (_polygon513 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.41 11.14 14.42 11.16 14.43 11.16 14.42 11.12 14.41 11.14"
  })), _polygon514 || (_polygon514 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.4 11.19 14.38 11.23 14.4 11.22 14.4 11.19 14.4 11.19"
  })), _polygon515 || (_polygon515 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.44 11.18 14.44 11.19 14.48 11.16 14.45 11.16 14.44 11.18"
  })), _polygon516 || (_polygon516 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.38 11.18 14.4 11.17 14.4 11.16 14.36 11.16 14.38 11.18"
  })), _polygon517 || (_polygon517 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.42 11.2 14.42 11.21 14.45 11.23 14.45 11.21 14.42 11.2"
  })), _polygon518 || (_polygon518 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.12 10.58 14.12 10.59 14.15 10.61 14.15 10.59 14.12 10.58"
  })), _polygon519 || (_polygon519 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.11 10.52 14.12 10.54 14.13 10.54 14.12 10.5 14.11 10.52"
  })), _polygon520 || (_polygon520 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.08 10.55 14.1 10.55 14.1 10.54 14.06 10.54 14.08 10.55"
  })), _polygon521 || (_polygon521 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.14 10.56 14.14 10.57 14.18 10.54 14.15 10.54 14.14 10.56"
  })), _polygon522 || (_polygon522 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.1 10.57 14.08 10.61 14.1 10.6 14.1 10.57 14.1 10.57"
  })), _polygon523 || (_polygon523 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.38 11.06 14.38 11.06 14.37 11.1 14.38 11.09 14.38 11.06"
  })), _polygon524 || (_polygon524 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.43 11.08 14.41 11.07 14.4 11.07 14.44 11.1 14.43 11.08"
  })), _polygon525 || (_polygon525 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.39 11.03 14.35 11.03 14.36 11.04 14.39 11.04 14.39 11.03"
  })), _polygon526 || (_polygon526 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.43 11.05 14.46 11.03 14.44 11.03 14.42 11.05 14.43 11.05"
  })), _polygon527 || (_polygon527 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.4 11.01 14.41 11.03 14.42 11.03 14.4 10.99 14.4 11.01"
  })), _polygon528 || (_polygon528 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "8.02 11.81 8.07 11.77 8.07 11.67 8.06 11.66 8.02 11.81"
  })), _polygon529 || (_polygon529 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "8.25 11.74 8.16 11.7 8.14 11.72 8.28 11.81 8.25 11.74"
  })), _polygon530 || (_polygon530 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.99 11.61 8.08 11.58 8.08 11.56 7.93 11.56 7.99 11.61"
  })), _polygon531 || (_polygon531 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "8.19 11.55 8.14 11.4 8.12 11.49 8.16 11.56 8.19 11.55"
  })), _polygon532 || (_polygon532 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "8.23 11.65 8.36 11.56 8.27 11.56 8.21 11.63 8.23 11.65"
  })), _polygon533 || (_polygon533 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.71 10.48 6.62 10.44 6.6 10.46 6.74 10.55 6.71 10.48"
  })), _polygon534 || (_polygon534 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.65 10.29 6.61 10.14 6.58 10.23 6.62 10.3 6.65 10.29"
  })), _polygon535 || (_polygon535 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.45 10.34 6.54 10.32 6.54 10.3 6.39 10.3 6.45 10.34"
  })), _polygon536 || (_polygon536 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.48 10.55 6.53 10.51 6.54 10.41 6.52 10.4 6.48 10.55"
  })), _polygon537 || (_polygon537 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.73 10.3 6.67 10.37 6.69 10.39 6.82 10.3 6.73 10.3"
  })), _polygon538 || (_polygon538 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "9.07 11.78 9.13 11.8 9.15 11.79 9.05 11.71 9.07 11.78"
  })), _polygon539 || (_polygon539 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "9.04 11.92 9.09 11.86 9.08 11.84 8.97 11.91 9.04 11.92"
  })), _polygon540 || (_polygon540 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "9.21 11.76 9.2 11.83 9.22 11.84 9.28 11.72 9.21 11.76"
  })), _polygon541 || (_polygon541 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "9.11 11.93 9.15 12.05 9.17 12 9.12 11.92 9.11 11.93"
  })), _polygon542 || (_polygon542 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "9.19 11.93 9.33 11.93 9.28 11.89 9.2 11.91 9.19 11.93"
  })), _polygon543 || (_polygon543 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "8.77 11.7 8.81 11.72 8.81 11.71 8.76 11.66 8.77 11.7"
  })), _polygon544 || (_polygon544 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "8.76 11.77 8.78 11.74 8.78 11.74 8.72 11.77 8.76 11.77"
  })), _polygon545 || (_polygon545 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "8.79 11.78 8.81 11.85 8.82 11.82 8.8 11.78 8.79 11.78"
  })), _polygon546 || (_polygon546 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "8.84 11.78 8.91 11.78 8.88 11.76 8.84 11.77 8.84 11.78"
  })), _polygon547 || (_polygon547 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "8.85 11.69 8.84 11.73 8.85 11.74 8.88 11.67 8.85 11.69"
  })), _polygon548 || (_polygon548 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "10.25 12.67 10.27 12.63 10.27 12.63 10.21 12.66 10.25 12.67"
  })), _polygon549 || (_polygon549 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "10.31 12.6 10.25 12.55 10.27 12.59 10.3 12.61 10.31 12.6"
  })), _polygon550 || (_polygon550 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "10.34 12.58 10.33 12.62 10.35 12.63 10.37 12.56 10.34 12.58"
  })), _polygon551 || (_polygon551 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "10.33 12.67 10.4 12.68 10.38 12.65 10.33 12.66 10.33 12.67"
  })), _polygon552 || (_polygon552 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "9.01 11.66 9 11.69 9.01 11.69 9.03 11.65 9.01 11.66"
  })), _polygon553 || (_polygon553 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "8.97 11.72 8.98 11.76 8.99 11.74 8.98 11.72 8.97 11.72"
  })), _polygon554 || (_polygon554 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "8.96 11.67 8.98 11.68 8.99 11.67 8.95 11.65 8.96 11.67"
  })), _polygon555 || (_polygon555 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "9 11.72 9.04 11.72 9.03 11.71 9 11.71 9 11.72"
  })), _polygon556 || (_polygon556 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "8.95 11.71 8.96 11.7 8.96 11.69 8.93 11.71 8.95 11.71"
  })), _polygon557 || (_polygon557 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "9.24 12.18 9.22 12.16 9.19 12.17 9.19 12.17 9.24 12.18"
  })), _polygon558 || (_polygon558 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "9.17 12.17 9.18 12.21 9.18 12.2 9.17 12.17 9.17 12.17"
  })), _polygon559 || (_polygon559 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "9.18 12.13 9.15 12.1 9.15 12.13 9.17 12.13 9.18 12.13"
  })), _polygon560 || (_polygon560 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "9.2 12.15 9.22 12.11 9.2 12.12 9.2 12.14 9.2 12.15"
  })), _polygon561 || (_polygon561 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "9.16 12.15 9.12 12.17 9.14 12.17 9.16 12.15 9.16 12.15"
  })), _polygon562 || (_polygon562 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "8.75 12 8.75 12.03 8.76 12.03 8.77 11.99 8.75 12"
  })), _polygon563 || (_polygon563 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "8.75 12.06 8.79 12.06 8.78 12.04 8.75 12.05 8.75 12.06"
  })), _polygon564 || (_polygon564 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "8.7 12.05 8.71 12.03 8.71 12.03 8.68 12.05 8.7 12.05"
  })), _polygon565 || (_polygon565 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "8.73 12.01 8.7 11.98 8.71 12.01 8.73 12.02 8.73 12.01"
  })), _polygon566 || (_polygon566 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "8.74 12.08 8.73 12.05 8.72 12.05 8.73 12.1 8.74 12.08"
  })), _polygon567 || (_polygon567 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "9.13 12.25 9.14 12.25 9.15 12.22 9.14 12.23 9.13 12.25"
  })), _polygon568 || (_polygon568 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "9.07 12.27 9.09 12.27 9.1 12.26 9.1 12.25 9.07 12.27"
  })), _polygon569 || (_polygon569 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "9.1 12.23 9.12 12.24 9.12 12.24 9.09 12.22 9.1 12.23"
  })), _polygon570 || (_polygon570 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "9.11 12.28 9.12 12.31 9.12 12.29 9.11 12.27 9.11 12.28"
  })), _polygon571 || (_polygon571 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "9.13 12.27 9.13 12.28 9.17 12.28 9.15 12.27 9.13 12.27"
  })), _polygon572 || (_polygon572 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "8.94 11.92 8.9 11.93 8.9 11.94 8.96 11.94 8.94 11.92"
  })), _polygon573 || (_polygon573 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "8.87 11.93 8.86 11.94 8.88 11.99 8.89 11.97 8.87 11.93"
  })), _polygon574 || (_polygon574 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "8.9 11.89 8.91 11.9 8.93 11.84 8.91 11.86 8.9 11.89"
  })), _polygon575 || (_polygon575 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "8.83 11.93 8.85 11.9 8.85 11.9 8.8 11.93 8.83 11.93"
  })), _polygon576 || (_polygon576 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "8.85 11.87 8.87 11.88 8.88 11.87 8.84 11.84 8.85 11.87"
  })), _polygon577 || (_polygon577 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.95 10.29 6.94 10.33 6.95 10.33 6.97 10.28 6.95 10.29"
  })), _polygon578 || (_polygon578 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.94 10.37 7 10.37 6.98 10.36 6.94 10.36 6.94 10.37"
  })), _polygon579 || (_polygon579 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.9 10.37 6.92 10.42 6.93 10.4 6.91 10.37 6.9 10.37"
  })), _polygon580 || (_polygon580 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.89 10.33 6.84 10.36 6.87 10.37 6.89 10.34 6.89 10.33"
  })), _polygon581 || (_polygon581 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.91 10.32 6.92 10.31 6.88 10.27 6.88 10.3 6.91 10.32"
  })), _polygon582 || (_polygon582 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.79 10.63 6.81 10.58 6.78 10.59 6.78 10.63 6.79 10.63"
  })), _polygon583 || (_polygon583 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.76 10.7 6.74 10.67 6.74 10.67 6.75 10.72 6.76 10.7"
  })), _polygon584 || (_polygon584 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.75 10.61 6.71 10.57 6.72 10.6 6.75 10.62 6.75 10.61"
  })), _polygon585 || (_polygon585 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.67 10.66 6.7 10.66 6.72 10.64 6.72 10.63 6.67 10.66"
  })), _polygon586 || (_polygon586 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.81 10.65 6.77 10.66 6.77 10.67 6.83 10.67 6.81 10.65"
  })), _polygon587 || (_polygon587 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "8.94 12.17 8.96 12.25 8.97 12.21 8.94 12.16 8.94 12.17"
  })), _polygon588 || (_polygon588 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "8.89 12.16 8.92 12.12 8.91 12.11 8.85 12.16 8.89 12.16"
  })), _polygon589 || (_polygon589 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "9 12.11 9.01 12.11 9.04 12.03 9 12.06 9 12.11"
  })), _polygon590 || (_polygon590 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "9.05 12.14 8.99 12.16 8.99 12.17 9.08 12.17 9.05 12.14"
  })), _polygon591 || (_polygon591 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "8.96 12.08 8.9 12.03 8.91 12.07 8.95 12.09 8.96 12.08"
  })), _polygon592 || (_polygon592 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "10.56 12.68 10.56 12.69 10.64 12.7 10.61 12.67 10.56 12.68"
  })), _polygon593 || (_polygon593 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "10.52 12.61 10.53 12.6 10.47 12.55 10.48 12.59 10.52 12.61"
  })), _polygon594 || (_polygon594 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "10.5 12.69 10.53 12.77 10.54 12.74 10.51 12.69 10.5 12.69"
  })), _polygon595 || (_polygon595 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "10.41 12.68 10.46 12.68 10.49 12.65 10.48 12.64 10.41 12.68"
  })), _polygon596 || (_polygon596 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "10.57 12.58 10.56 12.63 10.58 12.64 10.61 12.56 10.57 12.58"
  })), _polygon597 || (_polygon597 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "10.89 12.46 10.97 12.46 10.94 12.44 10.89 12.45 10.89 12.46"
  })), _polygon598 || (_polygon598 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "10.9 12.35 10.89 12.4 10.91 12.41 10.94 12.33 10.9 12.35"
  })), _polygon599 || (_polygon599 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "10.87 12.51 10.84 12.46 10.83 12.46 10.86 12.54 10.87 12.51"
  })), _polygon600 || (_polygon600 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "10.79 12.45 10.82 12.42 10.81 12.41 10.74 12.45 10.79 12.45"
  })), _polygon601 || (_polygon601 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "10.86 12.37 10.8 12.32 10.81 12.36 10.85 12.38 10.86 12.37"
  })), _polygon602 || (_polygon602 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "9.44 11.92 9.46 11.89 9.46 11.88 9.4 11.92 9.44 11.92"
  })), _polygon603 || (_polygon603 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "9.52 11.93 9.59 11.93 9.56 11.91 9.52 11.92 9.52 11.93"
  })), _polygon604 || (_polygon604 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "9.46 11.85 9.49 11.86 9.5 11.85 9.44 11.81 9.46 11.85"
  })), _polygon605 || (_polygon605 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "9.47 11.93 9.49 11.99 9.5 11.96 9.48 11.93 9.47 11.93"
  })), _polygon606 || (_polygon606 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "9.53 11.84 9.52 11.88 9.53 11.88 9.56 11.82 9.53 11.84"
  })), _polygon607 || (_polygon607 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "8.5 11.9 8.54 12.05 8.57 11.99 8.52 11.9 8.5 11.9"
  })), _polygon608 || (_polygon608 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "8.46 11.72 8.53 11.76 8.55 11.74 8.43 11.64 8.46 11.72"
  })), _polygon609 || (_polygon609 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "8.61 11.88 8.6 11.9 8.76 11.91 8.71 11.86 8.61 11.88"
  })), _polygon610 || (_polygon610 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "8.62 11.7 8.61 11.79 8.64 11.8 8.7 11.65 8.62 11.7"
  })), _polygon611 || (_polygon611 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "8.41 11.89 8.47 11.82 8.46 11.8 8.34 11.89 8.41 11.89"
  })), _polygon612 || (_polygon612 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "9.33 12.09 9.4 12.12 9.42 12.1 9.3 12 9.33 12.09"
  })), _polygon613 || (_polygon613 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "9.37 12.27 9.41 12.41 9.44 12.35 9.39 12.26 9.37 12.27"
  })), _polygon614 || (_polygon614 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "9.47 12.25 9.47 12.27 9.63 12.28 9.57 12.23 9.47 12.25"
  })), _polygon615 || (_polygon615 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "9.28 12.25 9.34 12.19 9.33 12.17 9.21 12.25 9.28 12.25"
  })), _polygon616 || (_polygon616 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "9.48 12.16 9.51 12.17 9.57 12.02 9.49 12.07 9.48 12.16"
  })), _polygon617 || (_polygon617 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "10.23 12.37 10.31 12.18 10.22 12.24 10.2 12.36 10.23 12.37"
  })), _polygon618 || (_polygon618 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "10.06 12.49 10.12 12.68 10.15 12.6 10.08 12.49 10.06 12.49"
  })), _polygon619 || (_polygon619 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "9.86 12.47 9.95 12.48 10.03 12.39 10.02 12.37 9.86 12.47"
  })), _polygon620 || (_polygon620 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "10.32 12.44 10.2 12.47 10.19 12.5 10.39 12.51 10.32 12.44"
  })), _polygon621 || (_polygon621 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "10.13 12.28 9.98 12.16 10.01 12.27 10.1 12.31 10.13 12.28"
  })), _polygon622 || (_polygon622 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "11.99 12.87 11.93 12.8 11.94 12.85 11.98 12.88 11.99 12.87"
  })), _polygon623 || (_polygon623 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "12.03 12.85 12.02 12.9 12.03 12.91 12.08 12.84 12.03 12.85"
  })), _polygon624 || (_polygon624 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "12 12.96 12.09 12.98 12.06 12.95 12.01 12.95 12 12.96"
  })), _polygon625 || (_polygon625 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "11.94 12.91 11.94 12.89 11.86 12.93 11.9 12.94 11.94 12.91"
  })), _polygon626 || (_polygon626 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "11.96 13.04 11.98 13.01 11.96 12.95 11.95 12.95 11.96 13.04"
  })), _polygon627 || (_polygon627 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "11.85 12.64 11.91 12.6 11.9 12.58 11.79 12.63 11.85 12.64"
  })), _polygon628 || (_polygon628 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "11.98 12.54 11.9 12.44 11.91 12.52 11.96 12.55 11.98 12.54"
  })), _polygon629 || (_polygon629 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "11.93 12.79 11.96 12.74 11.93 12.66 11.92 12.66 11.93 12.79"
  })), _polygon630 || (_polygon630 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "12.05 12.52 12.02 12.59 12.04 12.61 12.11 12.49 12.05 12.52"
  })), _polygon631 || (_polygon631 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "12.09 12.66 12.01 12.66 12 12.68 12.13 12.71 12.09 12.66"
  })), _polygon632 || (_polygon632 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "12.76 12.62 12.75 12.62 12.76 12.74 12.79 12.7 12.76 12.62"
  })), _polygon633 || (_polygon633 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "12.87 12.47 12.85 12.55 12.87 12.56 12.94 12.45 12.87 12.47"
  })), _polygon634 || (_polygon634 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "12.73 12.53 12.62 12.58 12.68 12.6 12.74 12.55 12.73 12.53"
  })), _polygon635 || (_polygon635 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "12.92 12.62 12.83 12.62 12.83 12.63 12.96 12.66 12.92 12.62"
  })), _polygon636 || (_polygon636 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "12.79 12.51 12.81 12.49 12.73 12.4 12.74 12.47 12.79 12.51"
  })), _polygon637 || (_polygon637 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.19 12.77 13.2 12.89 13.23 12.85 13.2 12.77 13.19 12.77"
  })), _polygon638 || (_polygon638 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.06 12.73 13.12 12.74 13.18 12.7 13.17 12.68 13.06 12.73"
  })), _polygon639 || (_polygon639 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.27 12.77 13.27 12.78 13.4 12.81 13.36 12.76 13.27 12.77"
  })), _polygon640 || (_polygon640 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.38 12.6 13.31 12.62 13.29 12.7 13.31 12.71 13.38 12.6"
  })), _polygon641 || (_polygon641 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.18 12.62 13.23 12.65 13.25 12.64 13.17 12.55 13.18 12.62"
  })), _polygon642 || (_polygon642 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "11.26 12.54 11.14 12.5 11.19 12.56 11.26 12.56 11.26 12.54"
  })), _polygon643 || (_polygon643 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "11.21 12.7 11.23 12.63 11.22 12.62 11.15 12.72 11.21 12.7"
  })), _polygon644 || (_polygon644 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "11.35 12.43 11.31 12.49 11.33 12.56 11.35 12.56 11.35 12.43"
  })), _polygon645 || (_polygon645 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "11.43 12.59 11.35 12.63 11.36 12.65 11.48 12.6 11.43 12.59"
  })), _polygon646 || (_polygon646 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "11.28 12.68 11.36 12.79 11.36 12.73 11.29 12.68 11.28 12.68"
  })), _polygon647 || (_polygon647 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "12.66 12.91 12.65 12.92 12.69 12.97 12.69 12.94 12.66 12.91"
  })), _polygon648 || (_polygon648 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "12.6 12.85 12.64 12.85 12.64 12.84 12.58 12.82 12.6 12.85"
  })), _polygon649 || (_polygon649 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "12.58 12.94 12.61 12.93 12.63 12.89 12.62 12.88 12.58 12.94"
  })), _polygon650 || (_polygon650 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "12.69 12.89 12.69 12.9 12.76 12.88 12.73 12.87 12.69 12.89"
  })), _polygon651 || (_polygon651 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "12.69 12.85 12.69 12.78 12.67 12.81 12.68 12.85 12.69 12.85"
  })), _polygon652 || (_polygon652 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "11.45 12.87 11.45 12.88 11.49 12.86 11.47 12.86 11.45 12.87"
  })), _polygon653 || (_polygon653 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "11.43 12.89 11.43 12.89 11.45 12.92 11.45 12.9 11.43 12.89"
  })), _polygon654 || (_polygon654 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "11.44 12.85 11.45 12.85 11.45 12.81 11.44 12.83 11.44 12.85"
  })), _polygon655 || (_polygon655 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "11.4 12.89 11.41 12.87 11.41 12.87 11.38 12.9 11.4 12.89"
  })), _polygon656 || (_polygon656 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "11.42 12.84 11.38 12.83 11.4 12.85 11.42 12.85 11.42 12.84"
  })), _polygon657 || (_polygon657 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "12.78 12.88 12.81 12.86 12.83 12.81 12.82 12.81 12.78 12.88"
  })), _polygon658 || (_polygon658 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "12.8 12.77 12.84 12.77 12.85 12.76 12.77 12.73 12.8 12.77"
  })), _polygon659 || (_polygon659 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "12.87 12.85 12.86 12.85 12.91 12.91 12.91 12.88 12.87 12.85"
  })), _polygon660 || (_polygon660 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "12.91 12.82 12.91 12.83 12.99 12.8 12.95 12.79 12.91 12.82"
  })), _polygon661 || (_polygon661 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "12.89 12.77 12.91 12.77 12.91 12.69 12.88 12.72 12.89 12.77"
  })), _polygon662 || (_polygon662 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "12.99 12.54 13.03 12.52 13.04 12.47 13.04 12.47 12.99 12.54"
  })), _polygon663 || (_polygon663 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.12 12.35 13.09 12.38 13.11 12.43 13.12 12.43 13.12 12.35"
  })), _polygon664 || (_polygon664 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.07 12.51 13.13 12.57 13.13 12.54 13.08 12.51 13.07 12.51"
  })), _polygon665 || (_polygon665 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.06 12.43 13.06 12.42 12.99 12.39 13.02 12.43 13.06 12.43"
  })), _polygon666 || (_polygon666 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.17 12.45 13.12 12.48 13.13 12.49 13.21 12.46 13.17 12.45"
  })), _polygon667 || (_polygon667 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "11.61 12.47 11.54 12.45 11.57 12.48 11.6 12.48 11.61 12.47"
  })), _polygon668 || (_polygon668 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "11.69 12.49 11.65 12.52 11.66 12.53 11.72 12.5 11.69 12.49"
  })), _polygon669 || (_polygon669 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "11.62 12.54 11.66 12.6 11.66 12.57 11.62 12.54 11.62 12.54"
  })), _polygon670 || (_polygon670 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "11.65 12.41 11.63 12.44 11.64 12.48 11.65 12.48 11.65 12.41"
  })), _polygon671 || (_polygon671 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "11.58 12.55 11.59 12.51 11.58 12.51 11.55 12.56 11.58 12.55"
  })), _polygon672 || (_polygon672 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "11.54 12.75 11.62 12.75 11.63 12.72 11.49 12.68 11.54 12.75"
  })), _polygon673 || (_polygon673 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "11.74 12.75 11.74 12.59 11.69 12.66 11.71 12.75 11.74 12.75"
  })), _polygon674 || (_polygon674 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "11.74 12.86 11.89 12.8 11.82 12.78 11.74 12.84 11.74 12.86"
  })), _polygon675 || (_polygon675 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "11.49 12.95 11.56 12.92 11.59 12.83 11.58 12.82 11.49 12.95"
  })), _polygon676 || (_polygon676 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "11.75 12.95 11.66 12.89 11.65 12.89 11.75 13.02 11.75 12.95"
  })), _polygon677 || (_polygon677 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "12.45 12.66 12.49 12.66 12.49 12.45 12.42 12.54 12.45 12.66"
  })), _polygon678 || (_polygon678 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "12.18 12.9 12.27 12.87 12.3 12.76 12.28 12.74 12.18 12.9"
  })), _polygon679 || (_polygon679 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "12.24 12.65 12.34 12.65 12.35 12.62 12.17 12.56 12.24 12.65"
  })), _polygon680 || (_polygon680 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "12.39 12.83 12.38 12.84 12.5 12.99 12.5 12.91 12.39 12.83"
  })), _polygon681 || (_polygon681 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "12.49 12.77 12.5 12.79 12.69 12.72 12.6 12.69 12.49 12.77"
  })), _polygon682 || (_polygon682 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.8 11 7.75 10.85 7.72 10.94 7.77 11.01 7.8 11"
  })), _polygon683 || (_polygon683 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.68 11.22 7.68 11.12 7.67 11.11 7.62 11.26 7.68 11.22"
  })), _polygon684 || (_polygon684 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.86 11.19 7.76 11.15 7.75 11.17 7.88 11.26 7.86 11.19"
  })), _polygon685 || (_polygon685 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.69 11.01 7.54 11.01 7.6 11.05 7.69 11.03 7.69 11.01"
  })), _polygon686 || (_polygon686 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.82 11.08 7.83 11.1 7.97 11.01 7.88 11.01 7.82 11.08"
  })), _polygon687 || (_polygon687 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.5 12.52 13.47 12.46 13.45 12.47 13.48 12.56 13.5 12.52"
  })), _polygon688 || (_polygon688 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.57 12.29 13.53 12.32 13.53 12.39 13.54 12.4 13.57 12.29"
  })), _polygon689 || (_polygon689 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.47 12.37 13.48 12.36 13.4 12.29 13.41 12.35 13.47 12.37"
  })), _polygon690 || (_polygon690 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.34 12.46 13.4 12.46 13.44 12.42 13.42 12.4 13.34 12.46"
  })), _polygon691 || (_polygon691 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.59 12.43 13.52 12.45 13.52 12.46 13.63 12.46 13.59 12.43"
  })), _polygon692 || (_polygon692 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.82 12.49 13.82 12.5 13.93 12.5 13.89 12.48 13.82 12.49"
  })), _polygon693 || (_polygon693 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.83 12.37 13.83 12.43 13.84 12.44 13.88 12.34 13.83 12.37"
  })), _polygon694 || (_polygon694 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.75 12.51 13.79 12.61 13.8 12.56 13.77 12.51 13.75 12.51"
  })), _polygon695 || (_polygon695 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.64 12.5 13.7 12.5 13.73 12.46 13.72 12.44 13.64 12.5"
  })), _polygon696 || (_polygon696 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.77 12.41 13.79 12.4 13.7 12.33 13.71 12.39 13.77 12.41"
  })), _polygon697 || (_polygon697 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.73 12.15 13.75 12.16 13.76 12.15 13.73 12.13 13.73 12.15"
  })), _polygon698 || (_polygon698 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.75 12.19 13.76 12.23 13.76 12.21 13.75 12.19 13.75 12.19"
  })), _polygon699 || (_polygon699 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.73 12.19 13.74 12.18 13.74 12.17 13.71 12.19 13.73 12.19"
  })), _polygon700 || (_polygon700 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.79 12.13 13.78 12.14 13.77 12.17 13.78 12.17 13.79 12.13"
  })), _polygon701 || (_polygon701 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.77 12.19 13.77 12.19 13.81 12.19 13.8 12.18 13.77 12.19"
  })), _polygon702 || (_polygon702 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.65 12.63 13.65 12.63 13.71 12.63 13.69 12.61 13.65 12.63"
  })), _polygon703 || (_polygon703 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.54 12.63 13.55 12.61 13.53 12.62 13.53 12.65 13.53 12.65 13.54 12.63 13.57 12.63 13.6 12.6 13.59 12.59 13.54 12.63"
  })), _polygon704 || (_polygon704 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.61 12.63 13.63 12.69 13.63 12.66 13.61 12.63 13.61 12.63"
  })), _polygon705 || (_polygon705 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.66 12.55 13.65 12.59 13.66 12.59 13.68 12.53 13.66 12.55"
  })), _polygon706 || (_polygon706 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.62 12.58 13.63 12.57 13.57 12.53 13.58 12.56 13.62 12.58"
  })), _polygon707 || (_polygon707 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.36 11.64 14.29 11.66 14.29 11.67 14.4 11.67 14.36 11.64"
  })), _polygon708 || (_polygon708 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.22 11.68 14.25 11.78 14.27 11.73 14.23 11.68 14.22 11.68"
  })), _polygon709 || (_polygon709 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.19 11.61 14.1 11.67 14.16 11.67 14.2 11.63 14.19 11.61"
  })), _polygon710 || (_polygon710 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.3 11.6 14.31 11.61 14.35 11.5 14.3 11.53 14.3 11.6"
  })), _polygon711 || (_polygon711 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.18 11.55 14.24 11.58 14.25 11.56 14.16 11.49 14.18 11.55"
  })), _polygon712 || (_polygon712 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14 11.93 13.99 11.93 14.02 11.99 14.03 11.96 14 11.93"
  })), _polygon713 || (_polygon713 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.09 11.91 14.04 11.92 14.04 11.93 14.11 11.93 14.09 11.91"
  })), _polygon714 || (_polygon714 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.05 11.88 14.05 11.88 14.07 11.82 14.05 11.84 14.05 11.88"
  })), _polygon715 || (_polygon715 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.02 11.86 13.96 11.81 13.97 11.85 14.01 11.87 14.02 11.86"
  })), _polygon716 || (_polygon716 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.96 11.93 13.98 11.9 13.98 11.89 13.92 11.93 13.96 11.93"
  })), _polygon717 || (_polygon717 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.46 11.52 14.47 11.48 14.45 11.49 14.45 11.52 14.46 11.52"
  })), _polygon718 || (_polygon718 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.41 11.53 14.41 11.52 14.38 11.54 14.4 11.54 14.41 11.53"
  })), _polygon719 || (_polygon719 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.44 11.57 14.43 11.55 14.42 11.55 14.43 11.59 14.44 11.57"
  })), _polygon720 || (_polygon720 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.47 11.53 14.45 11.54 14.45 11.54 14.49 11.54 14.47 11.53"
  })), _polygon721 || (_polygon721 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.43 11.5 14.4 11.48 14.4 11.5 14.43 11.51 14.43 11.5"
  })), _polygon722 || (_polygon722 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.5 12.68 13.51 12.72 13.52 12.7 13.5 12.68 13.5 12.68"
  })), _polygon723 || (_polygon723 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.45 12.68 13.48 12.68 13.49 12.66 13.49 12.65 13.45 12.68"
  })), _polygon724 || (_polygon724 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.53 12.67 13.53 12.68 13.57 12.68 13.55 12.66 13.53 12.67"
  })), _polygon725 || (_polygon725 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.48 12.63 13.51 12.64 13.51 12.63 13.48 12.61 13.48 12.63"
  })), _polygon726 || (_polygon726 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.43 11.63 14.4 11.65 14.42 11.65 14.44 11.64 14.43 11.63"
  })), _polygon727 || (_polygon727 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.49 11.59 14.48 11.6 14.48 11.63 14.48 11.63 14.49 11.59"
  })), _polygon728 || (_polygon728 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.47 11.65 14.47 11.65 14.52 11.65 14.5 11.64 14.47 11.65"
  })), _polygon729 || (_polygon729 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.46 11.61 14.42 11.59 14.43 11.61 14.45 11.62 14.46 11.61"
  })), _polygon730 || (_polygon730 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.45 11.66 14.46 11.7 14.46 11.68 14.45 11.65 14.45 11.66"
  })), _polygon731 || (_polygon731 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.29 12.06 14.29 12.07 14.33 12.07 14.31 12.06 14.29 12.06"
  })), _polygon732 || (_polygon732 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.21 12.07 14.24 12.07 14.25 12.05 14.25 12.04 14.21 12.07"
  })), _polygon733 || (_polygon733 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.26 12.07 14.27 12.11 14.28 12.09 14.27 12.07 14.26 12.07"
  })), _polygon734 || (_polygon734 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.3 12.04 14.31 12 14.29 12.01 14.29 12.04 14.3 12.04"
  })), _polygon735 || (_polygon735 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.27 12.03 14.27 12.03 14.24 12 14.24 12.02 14.27 12.03"
  })), _polygon736 || (_polygon736 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.12 12.28 14.09 12.26 14.1 12.28 14.12 12.29 14.12 12.28"
  })), _polygon737 || (_polygon737 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.11 12.32 14.12 12.35 14.13 12.34 14.12 12.32 14.11 12.32"
  })), _polygon738 || (_polygon738 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.13 12.31 14.13 12.32 14.17 12.32 14.16 12.31 14.13 12.31"
  })), _polygon739 || (_polygon739 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.14 12.27 14.14 12.29 14.14 12.3 14.15 12.26 14.14 12.27"
  })), _polygon740 || (_polygon740 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.07 12.32 14.09 12.32 14.11 12.3 14.1 12.3 14.07 12.32"
  })), _polygon741 || (_polygon741 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.21 11.83 14.21 11.86 14.22 11.87 14.24 11.81 14.21 11.83"
  })), _polygon742 || (_polygon742 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.2 11.93 14.18 11.9 14.17 11.91 14.19 11.96 14.2 11.93"
  })), _polygon743 || (_polygon743 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.19 11.85 14.14 11.81 14.15 11.84 14.18 11.85 14.19 11.85"
  })), _polygon744 || (_polygon744 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.21 11.9 14.21 11.9 14.27 11.9 14.25 11.89 14.21 11.9"
  })), _polygon745 || (_polygon745 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.15 11.87 14.11 11.9 14.14 11.9 14.16 11.88 14.15 11.87"
  })), _polygon746 || (_polygon746 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.36 11.86 14.38 11.92 14.39 11.89 14.37 11.86 14.36 11.86"
  })), _polygon747 || (_polygon747 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.37 11.81 14.38 11.8 14.33 11.76 14.34 11.79 14.37 11.81"
  })), _polygon748 || (_polygon748 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.3 11.86 14.33 11.86 14.35 11.83 14.34 11.82 14.3 11.86"
  })), _polygon749 || (_polygon749 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.4 11.85 14.4 11.86 14.46 11.86 14.44 11.84 14.4 11.85"
  })), _polygon750 || (_polygon750 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.4 11.82 14.41 11.82 14.43 11.76 14.41 11.78 14.4 11.82"
  })), _polygon751 || (_polygon751 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.27 11.29 14.21 11.25 14.23 11.29 14.26 11.3 14.27 11.29"
  })), _polygon752 || (_polygon752 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.25 11.37 14.27 11.43 14.28 11.4 14.26 11.37 14.25 11.37"
  })), _polygon753 || (_polygon753 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.22 11.36 14.24 11.34 14.23 11.32 14.18 11.36 14.22 11.36"
  })), _polygon754 || (_polygon754 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.3 11.27 14.3 11.32 14.31 11.32 14.33 11.25 14.3 11.27"
  })), _polygon755 || (_polygon755 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.81 12.24 13.9 12.24 13.95 12.18 13.94 12.15 13.81 12.24"
  })), _polygon756 || (_polygon756 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.01 12.11 14.02 12.08 13.9 11.98 13.92 12.07 14.01 12.11"
  })), _polygon757 || (_polygon757 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.98 12.25 14.02 12.39 14.05 12.32 14 12.25 13.98 12.25"
  })), _polygon758 || (_polygon758 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.08 12.23 14.08 12.24 14.24 12.24 14.18 12.2 14.08 12.23"
  })), _polygon759 || (_polygon759 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.16 11.99 14.1 12.03 14.09 12.14 14.11 12.14 14.16 11.99"
  })), _polygon760 || (_polygon760 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.46 11.38 14.53 11.38 14.5 11.36 14.46 11.37 14.46 11.38"
  })), _polygon761 || (_polygon761 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.4 11.35 14.39 11.34 14.36 11.36 14.34 11.35 14.3 11.36 14.3 11.36 14.36 11.36 14.34 11.38 14.38 11.38 14.4 11.35"
  })), _polygon762 || (_polygon762 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.38 11.3 14.42 11.32 14.43 11.31 14.37 11.26 14.38 11.3"
  })), _polygon763 || (_polygon763 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.46 11.33 14.47 11.34 14.49 11.27 14.46 11.29 14.46 11.33"
  })), _polygon764 || (_polygon764 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.42 11.38 14.41 11.38 14.43 11.45 14.44 11.42 14.42 11.38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamilyProtectionIcon);
export default __webpack_public_path__ + "static/media/FamilyProtectionIcon.99bfd19ba6348121b2f76bd385f42d2e.svg";
export { ForwardRef as ReactComponent };